import { Component, OnInit, ViewChild } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import * as CryptoJS from "crypto-js";
import { MatDatepicker } from "@angular/material/datepicker";
import { formatDate } from "@angular/common";
import { Router } from "@angular/router";
import { GridOptions } from "ag-grid-community";
import { ElementRef } from "@angular/core";
//import 'ag-grid-enterprise';
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Observable, Subject } from "rxjs";
//import {saveFile, saveAs} from 'file-saver';
import { map, filter, catchError, mergeMap } from "rxjs/operators";
import { DatePipe } from "@angular/common";


import { FormGroup, FormBuilder } from "@angular/forms";
import * as $ from "jquery";

@Component({
  selector: "app-recovery-reports",
  templateUrl: "./recovery-reports.component.html",
  styleUrls: ["./recovery-reports.component.css"],
})
export class RecoveryReportsComponent implements OnInit {
  @ViewChild("InitiatedDate") InitiatedDate: MatDatepicker<Date>;
  @ViewChild("endDate") endDate: MatDatepicker<Date>;
  // @ViewChild("CountryList") public CountryList: DropDownListComponent;
  public CountryList:any="";
  public Reports: ReportDetails = new ReportDetails();
  public dlstDeviceType;
  public validate;
  public dlstReportType;
  public dlstCountry;
  public Role;
  public Country;
  public country;
  public UtilizationFacility;
  public Type;
  public RoleReport;
  public MarkList;
  public PXBAuthcode;
  public GatewayList;
  public CallTypeListTeams;
  public DeviceList;
  public TelcoList;
  public CallDirection;
  public UtilizationsFacility;
  public CallStatus;
  public checkbox1;
  public checkbox2;
  public checkbox3;
  public Utilizations;
  public StatusList;
  public PhoneMessage;
  public ProjectList;
  public showRecEIdlistbox;
  public DialInConferenceList;
  public TrunkList;
  public ReportTypes;
  public Countries;
  public SourceCountries;
  public DestinationCountries;
  public DeviceType;
  public TeamscallType = [];
  public divtxtCalleeNo = false;
  public divtxtCallerNo = false;
  public SelectedEnterpriseIDList;
  public SelectedEnterpriseIDInList;
  public DestinationTypeList;
  public SMENameList;
  public RequestTypeList;
  public CallTypeList;
  public FacilityList;
  public LocationList;
  public randomRefresh;
  public gridOptions: GridOptions;
  public columnDefs: any;
  public RetriveData: any;
  public rowData = [];
  public IsRetriveData:boolean = false;  
  public LoginEnterpriseID;
  public DeviceTypeList;
  public EIDList;
  public ProjectName;
  public destDeviceName;
  public Gateways;
  public DailInConff;
  public telcoName;
  public Description;
  public loaderGif:boolean = false;
  public DestinationTypes;
  public CallTypes;
  public ColumnType;
  public ColumnList;
  public ReportType;
  public gridApi;
  public excelStyles;
  public gridColumnApi;
  public IsDataToExport:boolean = false;
  public SelectedFacilities = [];
  public SelectedTelcoProviders = [];
  public SelectedGatewayNames = [];
  public SelectedDeviceList = [];
  public SelectedProjectNames = [];
  public selectedDailInConff = [];
  public selectedCallType = [];
  public selectedLocation = [];
  public slectedTeamsCallType = [];
  public selectedDestDeviType = [];
  public selectedSMECluster = [];
  public slectedCountries = [];
  public slectedToCountries = [];
  public MultiCountryFlag = false;
  public CountryFlag = true;
  CountryFields: Object = { text: "Country", value: "Country" };
  // DGData = [];
  recoveryReportFG: FormGroup;
  public BulkUploaddata;
  public TempUserKey = "";
  bulkFile: any;
  uploadResponse: any[];
  public MultiSelectToCountriesTeams;

  public dropDownSettings: IDropdownSettings = {
    itemsShowLimit: 2,
    idField: "label_id",
    allowSearchFilter: true,
    textField: "label",
    selectAllText: "Check All",
    unSelectAllText: "UnCheck All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: "No data available",
  };

  public dropDown: IDropdownSettings = {
    itemsShowLimit: 2,
    allowSearchFilter: true,
    textField: "label",
    selectAllText: "Check All",
    unSelectAllText: "UnCheck All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: "No data available",
  };

  public customDrpDwnSettings: IDropdownSettings = {
    itemsShowLimit: 1,
    idField: "label_id",
    allowSearchFilter: true,
    textField: "label",
    selectAllText: "Check All",
    unSelectAllText: "UnCheck All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: "No data available",
  };
  public customCntryDrpDwnSettings: IDropdownSettings = {
    itemsShowLimit: 1,
    idField: "label_id",
    allowSearchFilter: true,
    textField: "label",
    selectAllText: "All",
    unSelectAllText: "All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: "data available",
  };

  /* div controls */
  public txtcommonareaphone1 = false;
  public divcallType = false;
  public divcallTypeTeams = false;
  public divFacility = false;
  public divutilizationFacility = false;
  public utilizCountry = false;
  public divcall = false;
  public divTrunk = false;
  public divGateway = false;
  public divRecoveryReports = false;
  public divCommonareaPhone = false;
  public divProjectName = false;
  public divUtilizationReport = false;
  public CallChargeReport = false;
  public divteamscall1 = false;
  public divteamscall3 = false;
  public diveid = false;
  public divConference = false;
  public divteamscall2 = false;
  public teamsDestination = false;
  public chkCountryReportType = false;
  public bulkeid = false;
  public singleeid = false;

  public divSourceCountry = false;
  public divDestinationCountry = false;
  public SrcDestCountry = true;
  dynamicVariable = false;
  public divLocationReport = false;
  public UserCountry;
  public divAuthcode = false;
  public divAuthcodeRequestType = false;
  public divSMEcluster = false;
  public SMECountry = false;
  public divcountrymultiselectType = false;
  public MultiSelectCountriesTeams;
  public divcountryselectType = true;

  IsAuthCodeChecked = false;
  IsCountryChecked = false;
  IsCalledNumber = false;
  IsCallingNumber = false;
  IsDevices = false;
  DestType = false;
  EvntType = false;
  public href: string = "";

  public paginationOptions = {
    sort: null,
  };

  constructor(
    private CAPService: CAPService,
    private router: Router,
    private datePipe: DatePipe,
    private fb: FormBuilder
  ) {
    this.DeviceTypeList = [{ name: "Cisco" }, { name: "Teams" }];
    this.Reports.callingPartyNumber = "";
    this.Reports.CalleeNo = "";
    this.Reports.CallerNo = "";
    this.Reports.Country = "";
    this.Reports.SourceCountry = "";
    this.Reports.DestinationCountry = "";
    this.Reports.utilizationtype = "";
    this.Reports.UtilFacility = "";
    this.Reports.startDateTime = "";
    this.Reports.EndDate = "";
    this.Reports.Event = "";
    this.Reports.MarkStatus = "";
    this.Reports.ValidInvalid = "";
    this.Reports.CallStatus = "";
    this.Reports.CallDirection = "";
    this.Reports.fromMediationServer = "";
    this.Reports.callStatus = "";
    this.country = "";
    this.Type = "";
    this.dlstDeviceType = "";
    this.dlstReportType = "";
    this.dlstCountry = "";
    this.LoginEnterpriseID = CAPService.enterpriseid;
    this.Role = CAPService.ReportRole;
    this.RoleReport = CAPService.Role;
    this.Country = CAPService.country;
    this.DeviceType = this.dlstDeviceType;
    this.UserCountry = this.CAPService.UserCountry;
    this.href = window.location.href;

    //This code to redirect to India URL from Frankfrut server//
    // if (this.Country == 'India' && this.RoleReport == 'Global Admin') {
    //   window.open("https://mycalls-india.accenture.com", "_blank")
    // }
    //------------------------------------------------------//
    if (this.RoleReport == "Regional Voice Admin") {
      this.country = this.Country;
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    this.Reports.DestinationCountry = [];
    // this.CAPService.CountryList("N" , "ReportsCountry" ).subscribe(data => {
    //   this.Countries = data;
    // });
    this.CAPService.SourceCountryList("N", "N").subscribe((data) => {
      this.SourceCountries = data;
    });
    // this.CAPService.DestinationCountryList("N" , "N" ).subscribe(data => {
    //   this.DestinationCountries = data;
    // });
    this.CAPService.DestinationCountryList("N", "N").subscribe((data) => {
      this.DestinationCountries = data;
      this.MultiSelectToCountriesTeams = data;
      const MultiToCountryTypeObj = { MultiToCountryTypeArray: [] };
      for (let i = 1; i < data.length; i++) {
        const ToCountryType = { label_id: i, label: data[i].Country };
        MultiToCountryTypeObj.MultiToCountryTypeArray.push(ToCountryType);
      }
      this.MultiSelectToCountriesTeams =
        MultiToCountryTypeObj.MultiToCountryTypeArray;
    });
    this.CAPService.DropdownValues("MarkAsList", "All").subscribe((data) => {
      this.MarkList = data;
    });
    this.CAPService.DropdownValues("PXBAuthcode", "Cisco").subscribe((data) => {
      this.PXBAuthcode = data;
    });
    this.CAPService.DropdownValues("N", "N").subscribe((data) => {
      this.TrunkList = data;
    });
    this.CAPService.DropdownValues("StatusList", "Skype").subscribe((data) => {
      this.StatusList = data;
    });
    this.CAPService.DropdownValues("Utilization", "Cisco").subscribe((data) => {
      this.Utilizations = data;
    });
    this.CAPService.DropdownValues("CallDirection", "Cisco").subscribe(
      (data) => {
        this.CallDirection = data;
      }
    );
    this.CAPService.DropdownValues("CallStatus", "Cisco").subscribe((data) => {
      this.CallStatus = data;
    });
    this.CAPService.CountryList("N", "ReportsCountry").subscribe((data) => {
      // this.Countries = data;
      // debugger;
      this.MultiSelectCountriesTeams = data;
      const MultiCountryTypeObj = { MultiCountryTypeArray: [] };
      for (let i = 1; i < data.length; i++) {
        const CountryType = { label_id: i, label: data[i].Country };
        MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
      }
      this.MultiSelectCountriesTeams =
        MultiCountryTypeObj.MultiCountryTypeArray;
    });

    this.recoveryReportFG = this.fb.group({
      inputFile: "",
    });

    this.EIDList = [{ name: "Single" }, { name: "Bulk" }];

    $(document).ready(function () {
      $("#dlstCountry").find("span").removeAttr("role");
    });
  }

  showPicker(): void {
    this.InitiatedDate.open();
  }
  showEndDatePicker(): void {
    this.endDate.open();
  }

  formatDateValue(date: Date) {
    const format = "yyyy-MM-dd";
    const locale = "en-US";
    const result = formatDate(date, format, locale);
    return result;
  }

  calculateDiff(fromdate, todate) {
    const date1: any = new Date(fromdate);
    const date2: any = new Date(todate);
    const diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    return diffDays;
  }
  culateFinDiff(fromdate, todate) {
    const date1: any = new Date(fromdate);
    const date2: any = new Date(todate);
    if (date1 <= date2) {
      return true;
    } else {
      return false;
    }
  }
  calFinDiff(fromdate, todate) {
    const date1: any = new Date(fromdate);
    const date2: any = new Date(todate);
    const res = date2 - date1;

    return res;
  }

  Reset() {
    this.dlstReportType = "";
    this.Reports.Country = "";
    this.Reports.startDateTime = "";
    this.Reports.EndDate = "";
    this.Reports.callStatus = "";
    this.Reports.fromMediationServer = "";
    this.Reports.CallDirection = "";
    this.Reports.CallStatus = "";
    this.Reports.WBSE = "";
    this.Reports.RITMNumber;
    this.Reports.callingPartyNumber = "";
    this.Reports.originalCalledPartyNumber = "";
    this.Reports.ExcludeNumber = "";
    this.Reports.AuthCode = "";
    this.Reports.callingPartyNumber = "";
    this.Reports.utilizationtype = "";
    this.Reports.ValidInvalid = "";
    this.Reports.MarkStatus = "";
    this.Reports.Event = "";
    this.Reports.WBSE = "";
    this.Reports.RITMNumber;
    this.Reports.CallerNo = "";
    this.Reports.CalleeNo = "";
    this.Reports.eId = "";
    this.SelectedFacilities = [];
    this.selectedCallType = [];
    this.selectedLocation = [];
    this.slectedTeamsCallType = [];
    this.SelectedGatewayNames = [];
    this.SelectedDeviceList = [];
    this.DeviceList = [];
    this.SelectedTelcoProviders = [];
    this.SelectedProjectNames = [];
    this.selectedDestDeviType = [];
    this.selectedDailInConff = [];
    this.selectedSMECluster = [];
    this.divcountrymultiselectType = false;

    this.txtcommonareaphone1 = false;
    this.divcallType = false;
    this.divcallTypeTeams = false;
    this.divFacility = false;
    this.divutilizationFacility = false;
    this.utilizCountry = false;
    this.divcall = false;
    this.divTrunk = false;
    this.divGateway = false;
    this.divRecoveryReports = false;
    this.divCommonareaPhone = false;
    this.divProjectName = false;
    this.divUtilizationReport = false;
    this.CallChargeReport = false;
    this.divteamscall1 = false;
    this.divteamscall3 = false;
    this.diveid = false;
    this.divConference = false;
    this.divteamscall2 = false;
    this.teamsDestination = false;
    this.divAuthcode = false;
    this.divAuthcodeRequestType = false;
  }

  Clear() {
    debugger;
    //Clearing all the fields with default values
    this.Reports.Country = "";
    this.Reports.startDateTime = "";
    this.Reports.EndDate = "";
    this.Reports.callStatus = "";
    this.Reports.fromMediationServer = "";
    this.Reports.CallDirection = "";
    this.Reports.CallStatus = "";
    this.Reports.WBSE = "";
    this.Reports.RITMNumber="";
    this.Reports.callingPartyNumber = "";
    this.Reports.originalCalledPartyNumber = "";
    this.Reports.ExcludeNumber = "";
    this.Reports.AuthCode = "";
    this.Reports.callingPartyNumber = "";
    this.Reports.utilizationtype = "";
    this.Reports.ValidInvalid = "";
    this.Reports.MarkStatus = "";
    this.Reports.Event = "";
    this.Reports.WBSE = "";
    this.Reports.RITMNumber="";
    this.Reports.CallerNo = "";
    this.Reports.CalleeNo = "";
    this.Reports.eId = "";
    this.Reports.UtilFacility = "";
    this.SelectedFacilities = [];
    this.selectedCallType = [];
    this.selectedLocation = [];
    this.slectedTeamsCallType = [];
    this.SelectedGatewayNames = [];
    this.SelectedDeviceList = [];
    this.DeviceList = [];
    this.SelectedTelcoProviders = [];
    this.SelectedProjectNames = [];
    this.selectedDestDeviType = [];
    this.selectedDailInConff = [];
    this.UtilizationsFacility = [];
    this.Reports.fromDuration = "";
    this.Reports.toDuration = "";
    this.Reports.fromCost = "";
    this.Reports.toCost = "";
    this.Reports.SMEName = "";
    //this.MultiSelectCountriesTeams =[];
    this.Reports.Country = "";
    this.IsRetriveData = false;
    this.loaderGif = false;
    this.IsDataToExport = false;
    this.txtcommonareaphone1 = false;
    this.divcallType = false;
    this.divcallTypeTeams = false;
    this.divFacility = false;
    this.divutilizationFacility = false;
    this.utilizCountry = false;
    this.divcall = false;
    this.divTrunk = false;
    this.divGateway = false;
    this.divRecoveryReports = false;
    this.divCommonareaPhone = false;
    this.divProjectName = false;
    this.divUtilizationReport = false;
    this.CallChargeReport = false;
    this.divteamscall1 = false;
    this.divteamscall3 = false;
    this.diveid = false;
    this.divConference = false;
    this.divteamscall2 = false;
    this.teamsDestination = false;
    this.Reports.SourceCountry = "";
    this.Reports.DestinationCountry = "";
    this.slectedTeamsCallType = [];
    this.divSourceCountry = false;
    this.divDestinationCountry = false;
    this.dynamicVariable = false;
    this.chkCountryReportType = false;
    this.EvntType = false;
    this.divLocationReport = false;
    this.bulkFile = "";
    this.TempUserKey = "";
    if (this.SrcDestCountry == true) {
      // this.CountryList.value = null;
      this.CountryList = "";
    }
    this.SrcDestCountry = true;
    this.slectedCountries = [];
    this.selectedSMECluster = [];
    // this.divSMEcluster = false;
    // this.divcountrymultiselectType = false;
    // this.divcountryselectType = true;

    // this.Reports.fromDuration = "";
    // this.Reports.toDuration = "";
    // this.Reports.fromCost = "";
    // this.Reports.toCost = "";
  }

  GetFacility() {
    if (
      this.dlstReportType != "Finance Report" &&
      this.dlstReportType != "Utilization Reports" &&
      this.dlstReportType != "SME Cluster Utilization Report"
    ) {
      // this.Reports.Country = this.CountryList.value;
      this.Reports.Country = this.CountryList;
    }

    const MultiObj = { MultiDeviceArray: [] };
    const MultiProjectObj = { MultiProjectArray: [] };
    const MultiGatewayObj = { MultiGatewayArray: [] };
    // var MultiDailInConferenceObj = { MultiDailInConferenceArray: [] };
    const MultitelcoObj = { MultitelcoArray: [] };
    const MultiFacilityObj = { MultiFacilityArray: [] };
    const MultiLocationObj = { MultiLocationArray: [] };
    this.ProjectName = [];
    this.destDeviceName = [];
    this.Gateways = [];
    this.DailInConff = [];
    this.telcoName = [];
    this.Description = [];
    this.selectedLocation = [];
    this.SelectedFacilities = [];

    this.CallTypeList = [
      { label_id: 0, label: "LOCAL" },
      { label_id: 1, label: "STD" },
      { label_id: 2, label: "INTERNAL" },
      { label_id: 3, label: "ISD" },
      { label_id: 4, label: "TOLL FREE" },
      { label_id: 5, label: "INCOMING" },
    ];
    this.CallTypes = [];
    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Incoming" },
      { label_id: 4, label: "Tollfree" },
    ];
    this.DestinationTypes = [];

    this.CAPService.FacilityList(this.Reports.Country).subscribe((data) => {
      this.FacilityList = data;
      for (let i = 0; i < data.length; i++) {
        const fac = { label_id: i, label: this.FacilityList[i].Description };
        MultiFacilityObj.MultiFacilityArray.push(fac);
      }
      this.FacilityList = MultiFacilityObj.MultiFacilityArray;
    });
    //   this.CAPService.FacilityList(this.Reports.Country).subscribe(data =>{
    //     this.UtilizationsFacility = data;
    // });

    const CountryValue =
      this.Reports.Country == "All"
        ? "N"
        : this.Reports.Country == ""
        ? "N"
        : this.Reports.Country;

    this.CAPService.GetVoiceAdminDetails(
      null,
      "LocationDropdown",
      CountryValue
    ).subscribe((data) => {
      this.LocationList = data;
      for (let i = 0; i < this.LocationList.length; i++) {
        const Location = { label_id: i, label: this.LocationList[i].Location };

        MultiLocationObj.MultiLocationArray.push(Location);
      }
      this.LocationList = MultiLocationObj.MultiLocationArray;
    });
    this.CAPService.GetVoiceAdminDetails(
      this.DeviceType,
      "Project",
      CountryValue
    ).subscribe((data) => {
      this.ProjectList = data;
      for (let i = 0; i < this.ProjectList.length; i++) {
        const Projects = {
          label_id: i,
          label: this.ProjectList[i].ProjectName,
        };

        MultiProjectObj.MultiProjectArray.push(Projects);
      }
      this.ProjectList = MultiProjectObj.MultiProjectArray;
    });
    if (this.dlstReportType != "Gateway Report" && this.DeviceType != "Teams") {
      this.CAPService.GetVoiceAdminDetails(
        this.DeviceType,
        "GatewaysNames",
        CountryValue
      ).subscribe((data) => {
        this.GatewayList = data;
        for (let i = 0; i < data.length; i++) {
          const Gateway = { label_id: i, label: data[i].Name };

          MultiGatewayObj.MultiGatewayArray.push(Gateway);
        }
        this.GatewayList = MultiGatewayObj.MultiGatewayArray;
      });
    }
    // this.CAPService.GetVoiceAdminDetails(this.DeviceType,"DialInConferenceNo",CountryValue).subscribe(data =>{
    //   this.DialInConferenceList = data
    //   for (var i = 0; i < data.length; i++) {

    //       var DialInConference = {label_id: i , label: data[i].DailInConferenceNumber }

    //       MultiDailInConferenceObj.MultiDailInConferenceArray.push(DialInConference);
    //   }
    //   this.DialInConferenceList = MultiDailInConferenceObj.MultiDailInConferenceArray;
    // });
    this.CAPService.GetVoiceAdminDetails(
      this.DeviceType,
      "Telco",
      CountryValue
    ).subscribe((data) => {
      this.TelcoList = data;
      let uniqueTelcoList = this.TelcoList.map((x) => x.telcoName);
      uniqueTelcoList = uniqueTelcoList.filter(
        (val, index) => uniqueTelcoList.indexOf(val) == index
      );

      for (let i = 0; i < uniqueTelcoList.length; i++) {
        const Telco = { label_id: i, label: uniqueTelcoList[i] };

        MultitelcoObj.MultitelcoArray.push(Telco);
      }
      this.TelcoList = MultitelcoObj.MultitelcoArray;
    });
    this.CAPService.GetVoiceAdminDetails(
      this.DeviceType,
      "DevicesNames",
      CountryValue
    ).subscribe((data) => {
      this.DeviceList = data;
      for (let i = 0; i < data.length; i++) {
        const Devices = { label_id: i, label: data[i].deviceName };

        MultiObj.MultiDeviceArray.push(Devices);
      }
      this.DeviceList = MultiObj.MultiDeviceArray;
    });
  }

  GreyCallType() {
    let calltypeNames = "";
    for (let i = 0; i < this.CallTypes.length; i++) {
      calltypeNames = calltypeNames + "," + this.CallTypes[i];
    }
    if (calltypeNames == "dr_in") {
      this.DestinationTypeList = [{ label_id: 0, label: "" }];
    } else {
      this.DestinationTypeList = [
        { label_id: 0, label: "Local" },
        { label_id: 1, label: "National" },
        { label_id: 2, label: "International" },
        { label_id: 3, label: "Tollfree" },
      ];
    }
  }

  toggleSelection() {
    if (this.IsCallingNumber) {
      this.Reports.callingPartyNumber = null;
    } else {
      this.Reports.fromCalling = null;
      this.Reports.toCalling = null;
    }
  }

  toggleSelection1() {
    if (this.IsCalledNumber) {
      this.Reports.originalCalledPartyNumber = null;
    } else {
      this.Reports.fromCalled = null;
      this.Reports.toCalled = null;
    }
  }
  toggleSelection2() {
    if (this.IsAuthCodeChecked) {
      this.Reports.AuthCode = null;
    } else {
      this.Reports.fromAuthcode = null;
      this.Reports.toAuthcode = null;
    }
  }

  GreyCallee() {
    this.ReportType = this.dlstReportType;
    const phone = this.Reports.callingPartyNumber.toString().trim();
    if (this.ReportType == "Call Detail Report") {
      if (phone.length > 0) {
        this.divtxtCalleeNo = false;
        this.divtxtCallerNo = false;
      } else {
        this.divtxtCalleeNo = true;
        this.divtxtCallerNo = true;
      }
    }
  }

  GreyPhone() {
    this.ReportType = this.dlstReportType;
    const CalleeNo = this.Reports.CalleeNo.toString().trim();
    const CallerNo = this.Reports.CallerNo.toString().trim();
    if (this.ReportType == "Call Detail Report") {
      if (CalleeNo.length > 0 || CallerNo.length > 0) {
        this.txtcommonareaphone1 = true;
        this.DestinationTypeList = [{ label_id: 0, label: "" }];
      } else {
        this.txtcommonareaphone1 = false;
        this.DestinationTypeList = [
          { label_id: 0, label: "Local" },
          { label_id: 1, label: "National" },
          { label_id: 2, label: "International" },
          { label_id: 3, label: "Tollfree" },
        ];
      }
    }
  }

  // GetEnterpriseID(){
  //   if(this.Reports.eId.length >= 3){
  //     this.loaderGif = true;
  //     this.CAPService.GetEnterpriseIDList(this.Reports.eId).subscribe(data =>{
  //       this.SelectedEnterpriseIDList = data;
  //       this.loaderGif = false;
  //     }, (err) => {
  //       this.loaderGif = false;
  //     });
  //     this.showRecEIdlistbox = true;
  //   }
  //   else{
  //     this.showRecEIdlistbox = false;
  //     this.loaderGif = false;
  //   }
  // }

  // PostEnterpriseID() {
  //   this.showRecEIdlistbox = false;
  //   if(this.SelectedEnterpriseIDInList != ""){
  //     this.Reports.eId = this.SelectedEnterpriseIDInList[0];
  //     //this.Reports.eId = this.SelectedEnterpriseIDInList;
  //     this.showRecEIdlistbox = false;
  //   }
  // }
  GetEnterpriseID() {
    if (this.Reports.eId.length >= 3) {
      this.CAPService.AutoPopulateGetEnterpriseIDList(
        this.Reports.eId
      ).subscribe(
        (data) => {
          this.SelectedEnterpriseIDList = data;
        },
        (err) => {}
      );
      this.showRecEIdlistbox = true;
    } else {
      this.showRecEIdlistbox = false;
    }
  }

  PostEnterpriseID() {
    this.showRecEIdlistbox = false;
    if (this.SelectedEnterpriseIDList != "") {
      this.Reports.eId = this.SelectedEnterpriseIDList[0];
      this.showRecEIdlistbox = false;
    }
  }

  AckAdd = function () {};
  //2023 requirement Bulk upload feature for Call details report instead of 5 userid search
  EnterpriseMember() {
    const i = this.Reports.eId;
    const keywordsArr = i.split(",");
    if (keywordsArr.length > 5) {
      alert("Only 5 or less Enterprise Id's are allowed");
    }
  }
  EIDTypeEvent(event: any) {
    const type = event.target.value;
    if (type == "Single") {
      this.bulkeid = false;
      this.singleeid = true;
      this.Reports.Status = "Single";
    } else {
      this.bulkeid = true;
      this.singleeid = false;
      this.Reports.Status = "Bulk";
    }
  }

  DeviceTypeEvent() {
    this.ReportType = "";
    this.Clear();
    this.loaderGif = true;
    this.DeviceType = this.dlstDeviceType;
    this.PhoneMessage = "Phone Number";
    this.CallTypeList = [
      { label_id: 0, label: "LOCAL" },
      { label_id: 1, label: "STD" },
      { label_id: 2, label: "INTERNAL" },
      { label_id: 3, label: "ISD" },
      { label_id: 4, label: "TOLL FREE" },
      { label_id: 5, label: "INCOMING" },
    ];
    this.CallTypes = [];
    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Tollfree" },
    ];
    this.DestinationTypes = [];
    // this.ColumnList = [ 'Display Name',
    //                     'SIP Address',
    //                     'CallerNumber',
    //                     'CalleeNumber',
    //                     'CallType' ,
    //                     'Destination Type',
    //                     'Number Type',
    //                     'Start Time',
    //                     'End Time',
    //                     'Invite Time',
    //                     'Failure Time',
    //                     'Duration',
    //                     'Call Cost',
    //                     'User Country',
    //                     'MediaByPass',
    //                     'SBCFqdn',
    //                     'AzureRegionforMedia',
    //                     'EventType',
    //                     'FinalSIPCode',
    //                     'FinalSIPCodePhrase',
    //                     'Correlation ID',
    //                     'Shared Correlation ID',
    //                     'Project / Group Name' ];
    this.ColumnType = [];
    // if (this.Role == 'Call Charge Report Access' && (this.DeviceType == 'Skype')) {
    //   this.ReportTypes.Value.push("Call Charge");
    // }
    // if (this.Role == 'Trunk Group Report Access' && (this.DeviceType == 'Skype')) {
    //   this.ReportTypes.Value.push("Trunk Group Report");
    // }
    // if (this.Role == 'Gateway Group Report Access' && (this.DeviceType == 'Skype')) {
    //   this.ReportTypes.Value.push("Gateway Group Report");
    // }
    // if (this.Role == 'Group Report' && (this.DeviceType == 'Skype')) {
    //   this.ReportTypes.Value.push("Group Report")
    // }
    // if (this.Role == 'CAPM Report Access' && (this.DeviceType == 'Skype')) {
    //   this.ReportTypes.Value.push("Common Area Phone Report");
    // }
    // if(this.Role == 'DialIn Report Access' && (this.DeviceType == 'Skype')) {
    //   this.ReportTypes.Value.push("Dial In Calls Reports")
    // }
    //---------------------
    this.ReportTypes = [];
    if (
      this.Role == "Call Charge Report Access" &&
      this.DeviceType == "Teams"
    ) {
      this.ReportTypes.push("Call Detail Report");
    }
    if (this.Role == "Gateway Report Access" && this.DeviceType == "Teams") {
      this.ReportTypes.push("Gateway Report");
    }
    if (this.Role == "Group Report" && this.DeviceType == "Teams") {
      this.ReportTypes.push("Project/Group Report");
    }
    /*2023 Requirement -- removal of Common Area Phone Report
    if (this.Role == 'CAPM Report Access' && (this.DeviceType == 'Teams' || this.DeviceType == 'Teams')) {
      this.ReportTypes.Value.push("Common Area Phone Report");
    }*/
    if (
      this.Role == "Trunk Group Report Access" &&
      this.DeviceType == "Teams"
    ) {
      this.ReportTypes.push("Dial In Conference Call Report");
    }
    if (this.UserCountry == "India") {
      if (
        (this.RoleReport == "Global Admin" ||
          this.RoleReport == "Regional Voice Admin") &&
        this.CAPService.DeviceType == "Cisco"
      ) {
        this.CAPService.GetVoiceAdminDetails(
          this.DeviceType,
          "ReportType",
          this.Country
        ).subscribe((data) => {
          this.ReportTypes = data;
          this.loaderGif = false;
        });
      } else if (
        this.RoleReport == "Global Admin" ||
        this.RoleReport == "Regional Voice Admin"
      ) {
        this.CAPService.DropdownValues("ReportType", this.DeviceType).subscribe(
          (data) => {
            this.ReportTypes = data;
            this.loaderGif = false;
          }
        );
      }
    } else {
      if (
        this.RoleReport == "Global Admin" ||
        this.RoleReport == "Regional Voice Admin"
      ) {
        this.CAPService.DropdownValues("ReportType", this.DeviceType).subscribe(
          (data) => {
            this.ReportTypes = data;
            this.loaderGif = false;
          }
        );
      }
    }
    if (this.RoleReport == "Finance Report") {
      if (
        this.RoleReport == "Finance Report" &&
        this.UserCountry == "India" &&
        (this.DeviceType == "Cisco" || this.DeviceType == "All")
      ) {
        this.CAPService.DropdownValues(
          "FinanceUser",
          this.DeviceType
        ).subscribe((data) => {
          this.ReportTypes = data;
          this.loaderGif = false;
        });
      } else {
        this.CAPService.DropdownValues(
          "FinanceUser",
          this.DeviceType
        ).subscribe((data) => {
          this.ReportTypes = data;
          this.ReportTypes.length = 0;
          this.loaderGif = false;
        });
      }
    }

    this.loaderGif = false;
    this.Reset();
  }

  ReportAction() {
    debugger;
    this.validate=false;
    if (this.dlstReportType == "SME Cluster Utilization Report") {
      this.divcountryselectType = false;
      this.divcountrymultiselectType = true;
    } else {
      this.divcountryselectType = true;
      this.divcountrymultiselectType = false;
    }

    this.Clear();
    this.ReportType = this.dlstReportType;
    this.DeviceType = this.dlstDeviceType;

    this.CallTypeList = [
      { label_id: 0, label: "LOCAL" },
      { label_id: 1, label: "STD" },
      { label_id: 2, label: "INTERNAL" },
      { label_id: 3, label: "ISD" },
      { label_id: 4, label: "TOLL FREE" },
      { label_id: 5, label: "INCOMING" },
    ];
    this.CallTypes = [];
    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Tollfree" },
    ];

    this.SMENameList = [
      { label_id: 0, label: "APA" },
      { label_id: 1, label: "AMR" },
      { label_id: 2, label: "EMEA" },
    ];

    this.CAPService.CountryList("N", "ReportsCountry").subscribe((data) => {
      this.Countries = data;
    });

    this.DestinationTypes = [];
    if (this.ReportType == "Dial In Conference Call Report") {
      this.CAPService.DropdownValues("CallTypeDIC", "Teams").subscribe(
        (data) => {
          this.CallTypeListTeams = data;
          const MultiCallTypeObj = { MultiCallTypeArray: [] };
          for (let i = 0; i < data.length; i++) {
            const CallType = { label_id: i, label: data[i].Value };
            MultiCallTypeObj.MultiCallTypeArray.push(CallType);
          }
          this.CallTypeListTeams = MultiCallTypeObj.MultiCallTypeArray;
        }
      );

      const MultiDailInConferenceObj = { MultiDailInConferenceArray: [] };
      this.CAPService.GetVoiceAdminDetails(
        this.DeviceType,
        "DialInConferenceNo",
        null
      ).subscribe((data) => {
        this.DialInConferenceList = data;
        for (let i = 0; i < data.length; i++) {
          if (data[i].CityName == null || data[i].CityName == "") {
            var DialInConference = {
              label_id: i,
              label: data[i].DailInConferenceNumber + " - " + data[i].country,
            };
          } else {
            var DialInConference = {
              label_id: i,
              label:
                data[i].DailInConferenceNumber +
                " - " +
                data[i].country +
                " - " +
                data[i].CityName,
            };
          }

          MultiDailInConferenceObj.MultiDailInConferenceArray.push(
            DialInConference
          );
        }
        this.DialInConferenceList =
          MultiDailInConferenceObj.MultiDailInConferenceArray;
      });
    } else {
      this.CAPService.DropdownValues("CallType", "Teams").subscribe((data) => {
        this.CallTypeListTeams = data;
        const MultiCallTypeObj = { MultiCallTypeArray: [] };
        for (let i = 0; i < data.length; i++) {
          const CallType = { label_id: i, label: data[i].Value };
          MultiCallTypeObj.MultiCallTypeArray.push(CallType);
        }
        this.CallTypeListTeams = MultiCallTypeObj.MultiCallTypeArray;
      });
    }

    if (this.DeviceType == "Teams") {
      this.IsCountryChecked = false;
      switch (this.ReportType) {
        case "Call Detail Report":
          this.diveid = true;
          this.divteamscall1 = true;
          this.divteamscall2 = true;
          this.divteamscall3 = true;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = true;
          this.divProjectName = false;
          this.divcallTypeTeams = true;
          this.divUtilizationReport = false;
          this.divcallType = false;
          this.teamsDestination = true;
          this.PhoneMessage = "Phone Number";
          this.CallChargeReport = false;
          this.divConference = false;
          this.IsDevices = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          break;
        case "Gateway Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false; //2023 Requirement Country Removal from Gateway report
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = true;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divcallTypeTeams = true;
          this.teamsDestination = true;
          this.IsDevices = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = false; //2023 Requirement Country Removal from Gateway report
          this.EvntType = true;
          this.divLocationReport = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Project/Group Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = true;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Phone Number";
          this.CallChargeReport = false;
          this.divcallTypeTeams = true;
          this.teamsDestination = true;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = true;
          this.divConference = false;
          this.IsDevices = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        /*2023 Requirement -- removal of Common Area Phone Report
          case 'Common Area Phone Report':
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divCommonareaPhone = true;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Common Area Phone Number";
          this.CallChargeReport = false;
          this.divcallTypeTeams = true;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = true;
          this.teamsDestination = true;
          this.divRecoveryReports = false;
          this.IsDevices = false;
          this.chkCountryReportType = false;
          this.divSourceCountry= false;
          this.divDestinationCountry= false;
          this.SrcDestCountry =true;
          this.divLocationReport =false;
          this.divAuthcode = false;
            this.divAuthcodeRequestType = false;
          break;*/
        case "Dial In Conference Call Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Conference Call Number";
          this.CallChargeReport = false;
          this.divcallTypeTeams = true;
          this.divConference = true;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.teamsDestination = false;
          this.DestType = false;
          this.EvntType = false;
          this.IsDevices = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = false;
          this.divLocationReport = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = true;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Country Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Conference Call Number";
          this.CallChargeReport = false;
          this.divcallTypeTeams = true;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.teamsDestination = false;
          this.DestType = false;
          this.EvntType = true;
          this.IsDevices = false;
          this.chkCountryReportType = true;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = true;
          this.singleeid = false;
          this.bulkeid = false;
          this.MultiCountryFlag = true;
          this.CountryFlag = false;
          this.dlstCountry = false;
          this.divcountryselectType = false;
          break;
        case "Location Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Conference Call Number";
          this.CallChargeReport = false;
          this.divcallTypeTeams = true;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.teamsDestination = false;
          this.DestType = false;
          this.EvntType = true;
          this.IsDevices = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = true;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
      }
    } else {
      switch (this.ReportType) {
        case "Call Charge":
          this.diveid = true;
          this.divcall = true;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = true;
          this.divProjectName = false;
          this.divcallType = true;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Phone Number";
          this.CallChargeReport = true;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Trunk Group Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = true;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = true;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Gateway Group Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = true;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = true;
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Recovery Reports":
          this.diveid = true;
          this.divcall = true;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = true;
          this.IsDevices = true;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = true;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.EvntType = false;
          this.DestType = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Common Area Phone Report":
          this.diveid = true;
          this.divcall = true;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = true;
          this.divProjectName = false;
          this.divcallType = true;
          this.divUtilizationReport = true;
          this.PhoneMessage = "Common Area Phone";
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Group Report":
          this.diveid = true;
          this.divcall = true;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = true;
          this.divcallType = true;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Utilization Reports":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = true;
          this.utilizCountry = true;
          this.SrcDestCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.EvntType = false;
          this.DestType = false;
          this.IsDevices = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Dial In Calls Reports":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Common Area Phone Reports":
          this.diveid = true;
          this.divcall = true;
          this.divTrunk = false;
          this.divFacility = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = true;
          this.divProjectName = false;
          this.divcallType = true;
          this.divUtilizationReport = false;
          this.PhoneMessage = "Common Area Phone";
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.IsDevices = false;
          this.EvntType = false;
          this.DestType = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Authcode Mapping Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Conference Call Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divConference = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Ghost Authcode Calls Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.SrcDestCountry = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.IsDevices = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.EvntType = false;
          this.DestType = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Finance Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = true;
          this.SrcDestCountry = false;
          this.divutilizationFacility = false;
          this.utilizCountry = true;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.IsDevices = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.EvntType = false;
          this.DestType = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Authcode Activation/Deactivation Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = true;
          this.SrcDestCountry = false;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.IsDevices = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.EvntType = false;
          this.DestType = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = true;
          this.divAuthcodeRequestType = true;
          this.divSMEcluster = false;
          this.divcountrymultiselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "SME Cluster Utilization Report":
          this.diveid = false;
          this.divcall = false;
          this.divTrunk = false;
          this.divFacility = false;
          this.SrcDestCountry = true;
          this.divutilizationFacility = false;
          this.utilizCountry = false;
          this.divGateway = false;
          this.divRecoveryReports = false;
          this.IsDevices = false;
          this.divCommonareaPhone = false;
          this.divProjectName = false;
          this.divcallType = false;
          this.divUtilizationReport = false;
          this.CallChargeReport = false;
          this.divteamscall1 = false;
          this.divteamscall2 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.EvntType = false;
          this.DestType = false;
          this.divcallTypeTeams = false;
          this.divAuthcode = false;
          this.divAuthcodeRequestType = false;
          this.divSMEcluster = true;
          this.divcountrymultiselectType = true;
          this.divcountryselectType = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
      }
    }
    if (this.ReportType == "Utilization Reports") {
      this.dynamicVariable = true;
      this.Reports.Country = "India";

      this.CAPService.FacilityList("India").subscribe((data) => {
        this.UtilizationsFacility = data;
      });
    } else if (this.dlstReportType == "Finance Report") {
      this.dynamicVariable = true;
      this.Reports.Country = "India";

      var MultiFacilityObj = { MultiFacilityArray: [] };

      this.CAPService.FacilityList("India").subscribe((data) => {
        this.FacilityList = data;
        for (let i = 0; i < data.length; i++) {
          const fac = { label_id: i, label: this.FacilityList[i].Description };
          MultiFacilityObj.MultiFacilityArray.push(fac);
        }
        this.FacilityList = MultiFacilityObj.MultiFacilityArray;
      });
    } else {
      this.dynamicVariable = false;
    }

    if (this.ReportType == "Authcode Activation/Deactivation Report") {
      var MultiFacilityObj = { MultiFacilityArray: [] };

      this.CAPService.AuthcodeFacility("AuthcodeFacility").subscribe((data) => {
        this.FacilityList = data;
        for (let i = 0; i < data.length; i++) {
          const fac = { label_id: i, label: this.FacilityList[i].Description };
          MultiFacilityObj.MultiFacilityArray.push(fac);
        }
        this.FacilityList = MultiFacilityObj.MultiFacilityArray;
      });
    }

    //2023 Requirement Gateway dropdown
    const MultiGatewayObj = { MultiGatewayArray: [] };
    if (this.DeviceType == "Teams" && this.ReportType == "Gateway Report") {
      this.CAPService.GetVoiceAdminDetails(
        this.DeviceType,
        "GatewaysNames",
        ""
      ).subscribe((data) => {
        this.GatewayList = data;
        for (let i = 0; i < data.length; i++) {
          const Gateway = { label_id: i, label: data[i].Name };

          MultiGatewayObj.MultiGatewayArray.push(Gateway);
        }
        this.GatewayList = MultiGatewayObj.MultiGatewayArray;
      });
    }
    // 2023 sprint 3 changes for India Server
    if (
      this.DeviceType == "Teams" &&
      this.href == "https://mycalls-india.accenture.com/Reports"
    ) {
      alert(
        "Teams report is not available for India. Please reach out to India voice team for any queries."
      );
    }
  }
  validateNumber(e: any) {
    const input = String.fromCharCode(e.charCode);
    //const reg = /^(\d{1,5}|\d{0,5}\.\d{1,2})$/;
    const reg = /^([0-9:]*)$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
    this.validate=true;
    if( this.Reports.startDateTime =="" && this.Reports.EndDate =="" && this.Reports.eId=="" && this.Reports.AuthCode=="" && this.Reports.WBSE=="")
    {
      this.validate=false;
    }
  }
  validatewbse(e: any)
  {
   const input=String.fromCharCode(e.charCode);
   this.validate=true;
    if(this.Reports.startDateTime =="" && this.Reports.EndDate =="" && this.Reports.eId=="" && this.Reports.AuthCode=="" && this.Reports.WBSE=="")
    {
      this.validate=false;
    }
  }
  validateeid(e: any)
  {
   const input=String.fromCharCode(e.charCode);
   this.validate=true;
    if(this.Reports.startDateTime =="" && this.Reports.EndDate =="" && this.Reports.eId=="" && this.Reports.AuthCode=="" && this.Reports.WBSE=="")
    {
      this.validate=false;
    }
  }
  validateDate(e:any)
  {
    
    const input=String.fromCharCode(e.charCode)
    this.validate=true;
    if( (this.Reports.startDateTime =="" || this.Reports.EndDate =="" ) && this.Reports.eId=="" && this.Reports.AuthCode=="" && this.Reports.WBSE=="")
    {

      this.validate=false;
    }
  

  }
 

  validateDecimalNumber(e: any) {
    const input = String.fromCharCode(e.charCode);
    //const reg = /^[\d+\.\d{0,2}+$]/;  ^(\d+)?([.]?\d{0,2})?$    /^\d+([.]?\d{0,2})?$/g;
    const reg = /^(\d?)?([.]?\d{0,2})?$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.setDomLayout("autoHeight");
    this.gridColumnApi = params.columnApi;
  }
  CountryReportType() {
    if (this.IsCountryChecked) {
      this.Reports.SourceCountry = "";
      this.Reports.DestinationCountry = "";
      this.Reports.Country = "";
      this.slectedTeamsCallType = [];
      this.SrcDestCountry = false;
      this.divSourceCountry = true;
      this.divDestinationCountry = true;
      this.dynamicVariable = true;
      this.IsRetriveData = false;
      this.IsDataToExport = false;
      this.loaderGif = false;
      this.divcountrymultiselectType = false;
      this.slectedCountries = [];
      this.slectedToCountries = [];
      if ((this.ReportType = "Country Report")) {
        this.MultiCountryFlag = true;
        this.CountryFlag = false;
      } else {
        this.MultiCountryFlag = false;
        this.CountryFlag = true;
      }
    } else {
      this.Reports.SourceCountry = "";
      this.Reports.DestinationCountry = "";
      this.Reports.Country = "";
      this.slectedTeamsCallType = [];
      this.divSourceCountry = false;
      this.divDestinationCountry = false;
      this.SrcDestCountry = true;

      this.dynamicVariable = false;
      this.IsRetriveData = false;
      this.IsDataToExport = false;
      this.loaderGif = false;
      this.selectedLocation = [];
      this.slectedCountries = [];
      this.slectedToCountries = [];
      this.MultiCountryFlag = false;
      this.CountryFlag = true;
      if ((this.ReportType = "Country Report")) {
        this.divcountrymultiselectType = true;
        this.divcountryselectType = false;
      } else {
        this.divcountrymultiselectType = false;
        this.divcountryselectType = true;
      }
    }
  }
  gridLoad() {
    debugger;
    let message = "";
    function validatePhone(txtPhone) {
      const filter = /^[0-9-+]+$/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    function validateRecovyDecimalNumber(Cost) {
      const filter = /^(\d+)?([.]?\d{0,2})?$/;
      if (filter.test(Cost)) {
        return true;
      } else {
        message =
          message +
          "\n" +
          "Please Enter Valid Integer or Decimal Number with 2 Decimal Places";
        return false;
      }
    }
    function ValidateFromCallDuration(Time) {
      const filter = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/;
      if (filter.test(Time)) {
        return true;
      } else {
        message = message + "\n" + "Please Enter Valid From Call Duration";
        return false;
      }
    }
    function ValidateToCallDuration(Time) {
      const filter = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/;
      if (filter.test(Time)) {
        return true;
      } else {
        message = message + "\n" + "Please Enter Valid To Call Duration";
        return false;
      }
    }

    const Date = this.calculateDiff(
      this.Reports.startDateTime,
      this.Reports.EndDate
    );
    const FinDate = this.culateFinDiff(
      this.Reports.startDateTime,
      this.Reports.EndDate
    );
    const grtDate = this.calculateDiff(
      this.Reports.startDateTime,
      this.Reports.EndDate
    );

    this.IsRetriveData = false;
    const concString = "";
    let Project = "";
    let GatewayNames = "";
    let Telco = "";
    let FacilityNames = "";
    let calltypeNames = "";
    let destinationtypeNames = "";
    let ColumnNames = "";
    let DailInConfNo = "";
    let LocationNames = "";
    let DeviceName = "";
    let SMEClusterName = "";

    if (this.dlstDeviceType == "") {
      message = "Please Select Device Type";
    }
    if (this.dlstReportType == "") {
      message = message + "\n" + "Please Select Report Type";
    }
    if (this.dlstReportType == "Authcode Activation/Deactivation Report") {
      if ((this.Reports.startDateTime == "" && !this.validate) || (this.Reports.EndDate == "" && !this.validate)) {
      
        message = message + "\n" + "Please enter Start Date and End Date";
      }
      if( (this.Reports.AuthCode == "" && !this.validate) || (this.Reports.WBSE == "" && !this.validate) || (this.Reports.eId == "" && !this.validate) ) {
        message = message + "\n" + "or Authcode/WBS Element/Enterprise ID ";
      } 
    }else
    {
      if (this.Reports.startDateTime == "" && !this.validate) {
       
        message = message + "\n" + "Please Select Start Date";
      }
      
      if (this.Reports.EndDate == "" && !this.validate) {
        
        message = message + "\n" + "Please Select End Date";
  
      }
    }
    if (this.IsCountryChecked) {
      if (this.ReportType == "Country Report") {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.slectedToCountries.length == 0) {
          message = message + "\n" + "Please Select To Country";
        }
      } else {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.Reports.DestinationCountry == "") {
          message = message + "\n" + "Please Select To Country";
        }
      }
    } else if (
      this.ReportType != "Dial In Conference Call Report" &&
      this.ReportType != "Ghost Authcode Calls Report" &&
      this.ReportType != "Authcode Activation/Deactivation Report" &&
      this.ReportType != "Gateway Report"
    ) {
      if (
        this.ReportType == "SME Cluster Utilization Report" ||
        this.ReportType == "Country Report"
      ) {
        if (this.slectedCountries.length == 0)
          message = message + "\n" + "Please Select Country";
      } else if (this.Reports.Country == "" || this.Reports.Country == null) {
        message = message + "\n" + "Please Select Country";
      }
    }
    if (this.ReportType == "SME Cluster Utilization Report") {
      if (this.selectedSMECluster.length == 0) {
        message = message + "\n" + "Please Select SME Name";
      }
    }
    if (this.dlstReportType == "Call Detail Report") {
      const eid = this.Reports.eId;
      const keywordsArr = eid.split(",");

      if (keywordsArr.length > 5) {
        message =
          message + "\n" + "Please Enter Only 5 or less Enterprise Id's";
      }
    }
    if (this.dlstReportType == "Utilization Reports") {
      if (this.Reports.UtilFacility == "") {
        message = message + "\n" + "Please Select Facility";
      }
    }
    if (this.dlstReportType == "Authcode Activation/Deactivation Report") {
      // if (this.SelectedFacilities.length == 0) {
      //   message = message + "\n" + "Please Select Facility";
      // }
      if (this.Reports.callStatus == "") {
        message = message + "\n" + "Please Select Request Type";
      }
    }
    if (this.dlstReportType == "Finance Report") {
      if (
        FinDate == false ||
        grtDate > 32 ||
        this.datePipe.transform(this.Reports.startDateTime, "dd") != "16" ||
        this.datePipe.transform(this.Reports.EndDate, "dd") != "15"
      ) {
        message =
          message +
          "\n" +
          "Kindly Select the Biling Period (16th to 15th of Current Biling Cycle) for the Date Criteria";
      }

      if (this.SelectedFacilities.length == 0) {
        message = message + "\n" + "Please Select Facility";
      }
    }
    if (this.dlstReportType == "Recovery Reports") {
      if (validateRecovyDecimalNumber(this.Reports.fromCost)) {
      }
      if (validateRecovyDecimalNumber(this.Reports.toCost)) {
      }
      if (this.Reports.fromDuration != "" || this.Reports.toDuration != "") {
        if (ValidateFromCallDuration(this.Reports.fromDuration)) {
        }
        if (ValidateToCallDuration(this.Reports.toDuration)) {
        }
      }
    }
    if (this.dlstReportType != "Recovery Reports") {
      if (this.Reports.callingPartyNumber != "") {
        if (validatePhone(this.Reports.callingPartyNumber)) {
        } else {
          if (this.dlstReportType == "Common Area Phone Report") {
            message =
              message +
              "\n" +
              "Please Enter Numeric in Common Area Phone Number";
          } else if (this.dlstReportType == "Dial In Conference Call Report") {
            message =
              message + "\n" + "Please Enter Numeric in Conference Call Number";
          } else {
            message = message + "\n" + "Please Enter Numeric in Phone Number";
          }
        }
      }
      if (this.Reports.CallerNo != "") {
        if (validatePhone(this.Reports.CallerNo)) {
        } else {
          message = message + "\n" + "Please Enter Numeric in Caller Number";
        }
      }
      if (this.Reports.CalleeNo != "") {
        if (validatePhone(this.Reports.CalleeNo)) {
        } else {
          message = message + "\n" + "Please Enter Numeric in Callee Number";
        }
      }
    }
    // if(Date > 7){
    //   message = message + "\n" + "Please Click on Export to Excel Button if Date selection is greater than 7 days!";
    // }

    if (message != "") {
      alert(message);
    } else {
      this.ReportType = this.dlstReportType;
      switch (this.ReportType) {
        case "Call Charge":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          } else {
            this.Type = "CallCharge";
          }
          break;
        case "Trunk Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "TrunkGroupReportTeams";
          } else {
            this.Type = "TrunkGroupReport";
          }
        case "Gateway Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GatewayReportTeams";
          } else {
            this.Type = "GatewayReport";
          }
          break;
        case "Recovery Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "RecoveryReportsTeams";
          } else {
            this.Type = "RecoveryReports";
          }
          break;
        case "Common Area Phone Report":
          {
            /*if (this.dlstDeviceType == 'Teams') {
                this.Type = 'CommonAreaPhoneReportTeams';
            } else {*/
            this.Type = "CommonAreaPhoneReport";
          }
          break;
        case "Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          } else {
            this.Type = "GroupReport";
          }
          break;
        case "Utilization Reports":
          this.Type = "UtilizationReport";
          break;
        case "Dial In Calls Reports":
          this.Type = "DialInCallsReports";
          break;
        case "Common Area Phone Reports":
          this.Type = "CiscoCommonAreaPhoneReport";
          break;
        case "Authcode Mapping Report":
          this.Type = "AuthcodeMappingReport";
          break;
        case "Conference Call Report":
          this.Type = "ConferenceCallReport";
          break;
        case "Call Detail Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          }
          break;
        case "Finance Report":
          this.Type = "FinanceReport";
          break;
        case "Authcode Activation/Deactivation Report":
          this.Type = "Active/DeActiveAuthcode";
          break;
        case "SME Cluster Utilization Report":
          this.Type = "SMEClusterUtilization";
          break;
        // case 'Call Detail Report':
        //     if (this.dlstDeviceType == 'Teams') {
        //         this.Type = 'CallChargeTeams';
        //     }
        //     break;
        case "Project/Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          }
          break;
        case "Dial In Conference Call Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInConferenceCallTeams";
          }
          break;
        case "Ghost Authcode Calls Report":
          this.Type = "GhostAuthcodeCallsReport";
          break;
        case "Country Report":
          if (this.dlstDeviceType == "Teams") {
            if (this.IsCountryChecked) {
              this.Type = "CountryReportTeams";
            } else {
              this.Type = "CountryRecoveryReportTeams";
            }
          }
          break;
        case "Location Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "LocationReportTeams";
          }
          break;
      }

      for (var i = 0; i < this.SelectedProjectNames.length; i++) {
        Project = Project + "," + this.SelectedProjectNames[i].label;
      }
      for (var i = 0; i < this.SelectedGatewayNames.length; i++) {
        GatewayNames = GatewayNames + "," + this.SelectedGatewayNames[i].label;
      }
      for (var i = 0; i < this.SelectedDeviceList.length; i++) {
        DeviceName = DeviceName + "," + this.SelectedDeviceList[i].label;
      }
      for (var i = 0; i < this.selectedDailInConff.length; i++) {
        //var res = this.selectedDailInConff[i].label.replace("+", "");
        DailInConfNo = DailInConfNo + "," + this.selectedDailInConff[i].label;
        //DailInConfNo = DailInConfNo + ',' + res
      }
      for (var i = 0; i < this.SelectedTelcoProviders.length; i++) {
        Telco = Telco + "," + this.SelectedTelcoProviders[i].label;
      }
      if (this.DeviceType == "Teams") {
        for (var i = 0; i < this.slectedTeamsCallType.length; i++) {
          calltypeNames =
            calltypeNames + "," + this.slectedTeamsCallType[i].label;
        }
        this.Reports.callType = calltypeNames.slice(1, calltypeNames.length);
      } else {
        for (var i = 0; i < this.selectedCallType.length; i++) {
          calltypeNames = calltypeNames + "," + this.selectedCallType[i].label;
        }
        this.Reports.callType = calltypeNames.slice(1, calltypeNames.length);

        for (var i = 0; i < this.selectedSMECluster.length; i++) {
          SMEClusterName =
            SMEClusterName + "," + this.selectedSMECluster[i].label;
        }
        this.Reports.SMEName = SMEClusterName.slice(1, SMEClusterName.length);
      }

      for (var i = 0; i < this.selectedLocation.length; i++) {
        LocationNames = LocationNames + "," + this.selectedLocation[i].label;
      }
      this.Reports.Location = LocationNames.slice(1, LocationNames.length);

      for (var i = 0; i < this.selectedDestDeviType.length; i++) {
        destinationtypeNames =
          destinationtypeNames + "," + this.selectedDestDeviType[i].label;
      }
      this.Reports.Destination = destinationtypeNames.slice(
        1,
        destinationtypeNames.length
      );

      for (var i = 0; i < this.SelectedFacilities.length; i++) {
        FacilityNames = FacilityNames + "~" + this.SelectedFacilities[i].label;
      }
      // 2023 sprint 4
      if (this.ReportType == "SME Cluster Utilization Report") {
        var countrySummaryCountry = "";
        for (var i = 0; i < this.slectedCountries.length; i++) {
          countrySummaryCountry =
            countrySummaryCountry + "," + this.slectedCountries[i].label;
        }
        this.Reports.Country = countrySummaryCountry.slice(
          1,
          countrySummaryCountry.length
        );
      }
      for (var i = 0; i < this.ColumnType.length; i++) {
        ColumnNames = ColumnNames + "," + this.ColumnType[i].label;
      }
      this.Reports.Column = ColumnNames.slice(1, ColumnNames.length);
      //this.Reports.destDeviceName = concString.slice(1, concString.length);
      this.Reports.destDeviceName = DeviceName.slice(1, DeviceName.length);
      this.Reports.ProjectName = Project.slice(1, Project.length);
      this.Reports.toGateway = GatewayNames.slice(1, GatewayNames.length);
      this.Reports.telcoName = Telco.slice(1, Telco.length);
      this.Reports.ProjectLead = this.LoginEnterpriseID;
      this.Reports.Facility = FacilityNames.slice(1, FacilityNames.length);
      this.Reports.DailInConference = DailInConfNo.slice(
        1,
        DailInConfNo.length
      );

      if (this.ReportType == "Dial In Conference Call Report") {
        this.Reports.Facility = DailInConfNo.slice(1, DailInConfNo.length);
      }
      let Enddate = "";
      if (this.Reports.utilizationtype == "Hourly") {
        Enddate = this.formatDateValue(this.Reports.startDateTime);
      } else if(!(this.Reports.EndDate=="")){
        
        Enddate = this.formatDateValue(this.Reports.EndDate);
      }

      if (this.ReportType == "Country Report") {
        if (this.IsCountryChecked) {
          let countrySummaryToCountry = "";

          for (var i = 0; i < this.slectedToCountries.length; i++) {
            countrySummaryToCountry =
              countrySummaryToCountry + "," + this.slectedToCountries[i].label;
          }

          this.Reports.DestinationCountry = countrySummaryToCountry.slice(
            1,
            countrySummaryToCountry.length
          );
        } else {
          var countrySummaryCountry = "";
          for (var i = 0; i < this.slectedCountries.length; i++) {
            countrySummaryCountry =
              countrySummaryCountry + "," + this.slectedCountries[i].label;
          }
          this.Reports.Country = countrySummaryCountry.slice(
            1,
            countrySummaryCountry.length
          );
        }
      }

      this.Reports.BulkUploadUserId = "";
      //2023 requirement Bulk upload feature for Call details report instead of 5 userid search
      if (
        this.bulkFile != "" &&
        this.bulkFile != undefined &&
        this.diveid &&
        this.divteamscall3
      ) {
        this.loaderGif = true;
        this.TempUserKey = "";
        const file = this.recoveryReportFG.controls.inputFile.value;
        const ext = file.split(".").pop().toLowerCase();
        if (file == "") {
          alert("Please Upload The Template");
          this.loaderGif = false;
          return;
        }
        if (ext != "xls" && ext != "xlsx") {
          alert(
            "Please upload only Excel file with .xls or .xlsx extension only"
          );
          $("#fileControl").val("");
          this.loaderGif = false;
        } else {
          const formData = new FormData();
          formData.append("file", this.bulkFile);
          this.CAPService.UploadBulkEidTemplate(
            this.LoginEnterpriseID,
            formData
          ).subscribe((data) => {
            this.BulkUploaddata = data;
            this.TempUserKey = this.BulkUploaddata.TempUserName;
            if (this.TempUserKey != "") {
              this.Reports.BulkUploadUserId = this.TempUserKey;
              this.getData(
                this.Reports,
                this.formatDateValue(this.Reports.startDateTime),
                Enddate,
                this.Type
              );
              // this.recoveryReportFG.controls.inputFile.setValue('');
            } else {
              this.loaderGif = false;
              //this.recoveryReportFG.controls.inputFile.setValue('');
              alert(this.BulkUploaddata.StrMessage);
            }
          });
        }
      } else {
        this.Reports.BulkUploadUserId = this.Reports.eId;
        if(this.dlstReportType.toString().startsWith("Authcode") && this.Reports.startDateTime == "" && this.Reports.EndDate == "")
        {
         this.CAPService.GetReportDetail(this.Reports,this.Type).subscribe((data)=>{
          console.log(data);
          this.IsRetriveData = true;
          if (this.Type == "Active/DeActiveAuthcode") {
            this.columnDefs = [
              { headerName: "Date & Time", field: "Date & Time" },
              { headerName: "AuthCode", field: "AuthCode" },
              { headerName: "Enterprise ID", field: "Enterprise ID" },
              { headerName: "Facility", field: "Facility" },
              { headerName: "WBS", field: "WBS" },
              { headerName: "AuthCode Status", field: "AuthCode Status" },
              { headerName: "Request Type", field: "Request Type" },
              { headerName: "RITM Number", field: "RITM Number" },
              { headerName: "Activated By", field: "Activated By" },
              { headerName: "DeActivated By", field: "Dectivated By" },
              { headerName: "Business Reason" , field: "Business Reason"} // 2051 - Added Business Reason column in grid to see which records are for exit deactivation 
            ];
          
           this.excelStyles = [
            {
              id: "darkGreyBackground",
              interior: {
                color: "#888888",
                pattern: "Solid",
              },
              font: {
                fontName: "Calibri Light",
                color: "#ffffff",
              },
            },
          ];
          this.rowData=data;
          this.gridOptions = {
            defaultColDef: {
              resizable: true,
              width: 300,
              sortable:true,
              filter: true,
            },
            columnDefs: this.columnDefs,
            pagination: true,
            animateRows: true,
            paginationPageSize: 10,
  
            getRowStyle: function (params) {
              if (params.node.rowIndex % 2 === 0) {
                return { background: "#FAFAFA" };
              } else {
                return { background: "#E5E5E5" };
              }
            },
          };
        }
        this.excelStyles = [
          {
            id: "darkGreyBackground",
            interior: {
              color: "#888888",
              pattern: "Solid",
            },
            font: {
              fontName: "Calibri Light",
              color: "#ffffff",
            },
          },
        ];
        if (
          this.ReportType == "Utilization Reports" ||
          this.ReportType == "Finance Report" ||
          this.ReportType == "Authcode Activation/Deactivation Report"
        ) {
          this.gridOptions = {
            defaultColDef: {
              resizable: true,
              width: 300,
              sortable:true,
              filter: true,
            },
            columnDefs: this.columnDefs,
            pagination: true,
            animateRows: true,
            paginationPageSize: 10,
  
            getRowStyle: function (params) {
              if (params.node.rowIndex % 2 === 0) {
                return { background: "#FAFAFA" };
              } else {
                return { background: "#E5E5E5" };
              }
            },
          };
        } 
  
        this.rowData = data;
        if (
          this.rowData.toString() == "Please Enter valid User EnterpriseID" &&
          this.Type == "CallChargeTeams"
        ) {
          alert("Please enter valid enterprise Id");
          this.IsRetriveData = false;
          this.loaderGif = false;
        } else if (
          data.toString() ==
          "Please Enter valid User EnterpriseID and ApplicationID"
        ) {
          alert(
            "Please enter valid enterprise Id or\nPlease enter valid application Id"
          );
          this.IsRetriveData = false;
          this.loaderGif = false;
        } else if (
          this.rowData.toString() == "Please Enter valid User EnterpriseID" &&
          this.Type == "Active/DeActiveAuthcode"
        ) {
          alert("Please Enter valid User EnterpriseID");
          this.IsRetriveData = false;
          this.loaderGif = false;
        } else if (
          this.rowData.toString() == "Please Enter Valid WBSE" &&
          this.Type == "Active/DeActiveAuthcode"
        ) {
          alert("Please Enter Valid WBSE");
          this.IsRetriveData = false;
          this.loaderGif = false;
        } else if (
          this.rowData.toString() == "Please Enter Valid RITM Number" &&
          this.Type == "Active/DeActiveAuthcode"
        ) {
          alert("Please Enter Valid RITM number");
          this.IsRetriveData = false;
          this.loaderGif = false;
        } else if (
          this.rowData.length > 0 &&
          (
            this.Type == "Active/DeActiveAuthcode")
        ) {
          this.IsRetriveData = true;
          this.IsDataToExport = true;
          this.loaderGif = false;
        } else {
          alert("No Data Available");
          this.IsRetriveData = false;
          this.loaderGif = false;
        }
        // {
        //   this.IsRetriveData = true;
        //   this.IsDataToExport = true;
        //   this.loaderGif = false;
        // } else {
        //   alert("No Data Available");
        //   this.IsRetriveData = false;
        //   this.loaderGif = false;
        // }

           

          
         });
        }
        else{
        this.getData(
          this.Reports,
          this.formatDateValue(this.Reports.startDateTime),
          Enddate,
          this.Type
        );
      }
      
      }
      
    }
  }

  getData(reports, initiateDate, EndDate, Type) {
    this.loaderGif = true;
    this.CAPService.GetReportDetails(
      reports,
      initiateDate,
      EndDate,
      Type
    ).subscribe((data) => {
      if (this.dlstDeviceType == "Teams") {
        if (this.ReportType == "Country Report") {
          if (this.Type == "CountryReportTeams") {
            this.columnDefs = [
              { headerName: "Display Name", field: "Display Name" },
              { headerName: "SIP Address", field: "SIP Address" },
              { headerName: "Caller Number", field: "Caller Number" },
              { headerName: "Callee Number", field: "Callee Number" },
              { headerName: "Call Type", field: "Call Type" },
              { headerName: "Destination Type", field: "Destination Type" },
              { headerName: "Number Type", field: "Number Type" },
              { headerName: "Start Time", field: "Start Time" },
              { headerName: "End Time", field: "End Time" },
              { headerName: "Invite Time", field: "Invite Time" },
              { headerName: "Failure Time", field: "Failure Time" },
              {
                headerName: "Duration In Minutes",
                field: "Duration In Minutes",
              },
              { headerName: "Call Cost", field: "Call Cost" },
              { headerName: "Source Country", field: "Source Country" },
              {
                headerName: "Destination Country",
                field: "Destination Country",
              },
              { headerName: "MediaByPass", field: "MediaByPass" },
              { headerName: "SBCFqdn", field: "SBCFqdn" },
              {
                headerName: "AzureRegionforMedia",
                field: "AzureRegionforMedia",
              },
              { headerName: "User Country", field: "User Country" },
              { headerName: "EventType", field: "EventType" },
              { headerName: "FinalSIPCode", field: "FinalSIPCode" },
              { headerName: "FinalSIPCodePhrase", field: "FinalSIPCodePhrase" },
              { headerName: "CorrelationId", field: "CorrelationId" },
              {
                headerName: "SharedCorrelationID",
                field: "SharedCorrelationID",
              },
            ];
          } else {
            this.columnDefs = [
              { headerName: "Display Name", field: "Display Name" },
              { headerName: "SIP Address", field: "SIP Address" },
              { headerName: "Caller Number", field: "Caller Number" },
              { headerName: "Callee Number", field: "Callee Number" },
              { headerName: "Call Type", field: "Call Type" },
              { headerName: "Destination Type", field: "Destination Type" },
              { headerName: "Number Type", field: "Number Type" },
              { headerName: "Start Time", field: "Start Time" },
              { headerName: "End Time", field: "End Time" },
              { headerName: "Invite Time", field: "Invite Time" },
              { headerName: "Failure Time", field: "Failure Time" },
              {
                headerName: "Duration In Minutes",
                field: "Duration In Minutes",
              },
              { headerName: "Call Cost", field: "Call Cost" },
              { headerName: "User Country", field: "User Country" },
              { headerName: "MediaByPass", field: "MediaByPass" },
              { headerName: "SBCFqdn", field: "SBCFqdn" },
              {
                headerName: "AzureRegionforMedia",
                field: "AzureRegionforMedia",
              },
              { headerName: "EventType", field: "EventType" },
              { headerName: "FinalSIPCode", field: "FinalSIPCode" },
              { headerName: "FinalSIPCodePhrase", field: "FinalSIPCodePhrase" },
              { headerName: "CorrelationId", field: "CorrelationId" },
              {
                headerName: "SharedCorrelationID",
                field: "SharedCorrelationID",
              },
            ];
          }
        } else if (this.ReportType == "Location Report") {
          this.columnDefs = [
            { headerName: "Display Name", field: "Display Name" },
            { headerName: "SIP Address", field: "SIP Address" },
            { headerName: "Caller Number", field: "Caller Number" },
            { headerName: "Callee Number", field: "Callee Number" },
            { headerName: "Call Type", field: "Call Type" },
            { headerName: "Destination Type", field: "Destination Type" },
            { headerName: "Number Type", field: "Number Type" },
            { headerName: "Start Time", field: "Start Time" },
            { headerName: "End Time", field: "End Time" },
            { headerName: "Invite Time", field: "Invite Time" },
            { headerName: "Failure Time", field: "Failure Time" },
            { headerName: "Duration In Minutes", field: "Duration In Minutes" },
            { headerName: "Call Cost", field: "Call Cost" },
            { headerName: "User Country", field: "User Country" },
            { headerName: "User Location", field: "User Location" },
            { headerName: "MediaByPass", field: "MediaByPass" },
            { headerName: "SBCFqdn", field: "SBCFqdn" },
            { headerName: "AzureRegionforMedia", field: "AzureRegionforMedia" },
            { headerName: "EventType", field: "EventType" },
            { headerName: "FinalSIPCode", field: "FinalSIPCode" },
            { headerName: "FinalSIPCodePhrase", field: "FinalSIPCodePhrase" },
            { headerName: "CorrelationId", field: "CorrelationId" },
            { headerName: "SharedCorrelationID", field: "SharedCorrelationID" },
          ];
        } else if (this.ReportType == "Dial In Conference Call Report") {
          this.columnDefs = [
            { headerName: "Call ID", field: "Call ID" },
            { headerName: "Conference ID", field: "Conference ID" },
            { headerName: "UPN", field: "UPN" },
            { headerName: "User Display Name", field: "User Display Name" },
            { headerName: "Caller ID", field: "Caller ID" },
            { headerName: "Call Type", field: "Call Type" },
            { headerName: "Number Type", field: "Number Type" },
            {
              headerName: "Domestic/International",
              field: "Domestic/International",
            },
            { headerName: "Destination Dialed", field: "Destination Dialed" },
            { headerName: "Destination Number", field: "Destination Number" },
            { headerName: "Start Time", field: "Start Time" },
            { headerName: "End Time", field: "End Time" },
            { headerName: "Duration In Minutes", field: "Duration In Minutes" },
            { headerName: "Connection Fee", field: "Connection Fee" },
            { headerName: "Charge", field: "Charge" },
            { headerName: "Currency", field: "Currency" },
            { headerName: "Capability", field: "Capability" },
          ];
        } else {
          this.columnDefs = [
            { headerName: "Display Name", field: "Display Name" },
            { headerName: "SIP Address", field: "SIP Address" },
            { headerName: "Caller Number", field: "Caller Number" },
            { headerName: "Callee Number", field: "Callee Number" },
            { headerName: "Call Type", field: "Call Type" },
            { headerName: "Destination Type", field: "Destination Type" },
            { headerName: "Number Type", field: "Number Type" },
            { headerName: "Start Time", field: "Start Time" },
            { headerName: "End Time", field: "End Time" },
            { headerName: "Invite Time", field: "Invite Time" },
            { headerName: "Failure Time", field: "Failure Time" },
            { headerName: "Duration In Minutes", field: "Duration In Minutes" },
            { headerName: "Call Cost", field: "Call Cost" },
            { headerName: "User Country", field: "User Country" },
            { headerName: "MediaByPass", field: "MediaByPass" },
            { headerName: "SBCFqdn", field: "SBCFqdn" },
            { headerName: "AzureRegionforMedia", field: "AzureRegionforMedia" },
            { headerName: "EventType", field: "EventType" },
            { headerName: "FinalSIPCode", field: "FinalSIPCode" },
            { headerName: "FinalSIPCodePhrase", field: "FinalSIPCodePhrase" },
            { headerName: "CorrelationId", field: "CorrelationId" },
            { headerName: "SharedCorrelationID", field: "SharedCorrelationID" },
          ];
        }
      }
      if (this.dlstDeviceType == "Cisco") {
        if (this.Type == "GhostAuthcodeCallsReport") {
          this.columnDefs = [
            { headerName: "Auth Code", field: "AuthCode" },
            { headerName: "Facility", field: "Facility" },
            { headerName: "Extn No", field: "Extn No" },
            { headerName: "Date", field: "date" },
            { headerName: "Time", field: "Time" },
            { headerName: "Called Number", field: "Called Number" },
            { headerName: "Duration", field: "Duration" },
            { headerName: "Cost", field: "Cost" },
            { headerName: "Country", field: "Country" },
          ];
        }
        // if(this.Type=="UtilizationReport"){
        //   this.columnDefs =[
        //     { headerName: "Location" , field: "Country",width: 250},
        //     { headerName: "Facility" , field: "Facility",width: 250},
        //     { headerName: "Date" , field: "StartTime",width: 250},
        //     { headerName: "Utilization Percentage" , field: "UtilizationPer",width: 300}

        //   ];
        // }
        if (this.Type == "UtilizationReport") {
          this.columnDefs = [
            { headerName: "Location", field: "Country", width: 250 },
            { headerName: "Facility", field: "Facility", width: 250 },
            { headerName: "Date", field: "startDateTime", width: 250 },
            {
              headerName: "Utilization Percentage",
              field: "Percentage",
              width: 300,
            },
          ];
        } else if (this.Reports.utilizationtype == "Hourly") {
          this.columnDefs = [
            { headerName: "Hour", field: "hour", width: 300 },
            { headerName: "Utilization", field: "utilization", width: 300 },
            { headerName: "Device Name", field: "deviceName", width: 600 },
          ];
        } else if (
          this.Reports.utilizationtype == "Monthly" ||
          this.Reports.utilizationtype == "Daily"
        ) {
          this.columnDefs = [
            { headerName: "Day Of Week", field: "dayOfWeek", width: 300 },
            { headerName: "Date", field: "date", width: 300 },
            { headerName: "Utilization", field: "utilization", width: 300 },
            { headerName: "Device Name", field: "deviceName", width: 300 },
          ];
        } else if (this.Type == "CiscoCommonAreaPhoneReport") {
          this.columnDefs = [
            { headerName: "Facility", field: "Facility" },
            { headerName: "Extn No", field: "callingPartyNumber" },
            { headerName: "Called Number", field: "CalledPartyNumber" },
            { headerName: "Date", field: "startDateTime" },
            { headerName: "Device", field: "destDeviceName" },
            { headerName: "Duration", field: "cduration" },
            { headerName: "Cost", field: "callCost" },
          ];
        } else if (this.Type == "FinanceReport") {
          this.columnDefs = [
            { headerName: "Facility", field: "Facility" },
            { headerName: "Charge Code", field: "Charge Code" },
            { headerName: "Enterprise ID", field: "Enterprise ID" },
            { headerName: "Employee ID", field: "Employee ID" },
            { headerName: "PSTN Duration", field: "PSTN Duration" },
            { headerName: "PSTN Cost", field: "PSTN Cost" },
            { headerName: "Total Cost", field: "Total Cost" },
          ];
        } else if (this.Type == "Active/DeActiveAuthcode") {
          this.columnDefs = [
            { headerName: "Date & Time", field: "Date & Time" },
            { headerName: "AuthCode", field: "AuthCode" },
            { headerName: "Enterprise ID", field: "Enterprise ID" },
            { headerName: "Facility", field: "Facility" },
            { headerName: "WBS", field: "WBS" },
            { headerName: "AuthCode Status", field: "AuthCode Status" },
            { headerName: "Request Type", field: "Request Type" },
            { headerName: "RITM Number", field: "RITM Number" },
            { headerName: "Activated By", field: "Activated By" },
            { headerName: "DeActivated By", field: "Dectivated By" },
            { headerName: "Business Reason" , field: "Business Reason"} // 2051 - Added Business Reason column in grid to see which records are for exit deactivation 
          ];
        } else if (this.Type == "SMEClusterUtilization") {
          this.columnDefs = [
            { headerName: "Country", field: "Country" },
            { headerName: "Extn No", field: "Extn No" },
            { headerName: "Date", field: "Date" },
            { headerName: "Time", field: "Time" },
            { headerName: "Called Number", field: "Called Number" },
            { headerName: "Duration", field: "Duration" },
            {
              headerName: "Original Device Name",
              field: "Original Device Name",
            },
            {
              headerName: "Destination Device Name",
              field: "Destination Device Name",
            },
            { headerName: "Call Direction", field: "Call Direction" },
            { headerName: "Trunk Name", field: "Trunk" },
            { headerName: "SME Name", field: "SME Name" },
          ];
        } else {
          this.columnDefs = [
            { headerName: "Auth Code", field: "AuthCode" },
            { headerName: "Facility", field: "Facility" },
            { headerName: "Extn No", field: "Extn No" },
            { headerName: "Date", field: "date" },
            { headerName: "Time", field: "Time" },
            { headerName: "Called Number", field: "Called Number" },
            { headerName: "Destination", field: "Destination" },
            { headerName: "Call Type", field: "callType" },
            { headerName: "Duration", field: "Duration" },
            { headerName: "Cost", field: "Cost" },
            { headerName: "Trunk", field: "Trunk" },
            { headerName: "Service Provider", field: "Service Provider" },
            { headerName: "Call Direction", field: "Call Direction" },
            { headerName: "Call Status", field: "Call Status" },
            { headerName: "Device", field: "Device" },
            { headerName: "Call Rate Name", field: "CallRateName" },
            { headerName: "Country", field: "Country" },
          ];
        }
      }
      this.excelStyles = [
        {
          id: "darkGreyBackground",
          interior: {
            color: "#888888",
            pattern: "Solid",
          },
          font: {
            fontName: "Calibri Light",
            color: "#ffffff",
          },
        },
      ];
      if (
        this.ReportType == "Utilization Reports" ||
        this.ReportType == "Finance Report" ||
        this.ReportType == "Authcode Activation/Deactivation Report"
      ) {
        this.gridOptions = {
          defaultColDef: {
            resizable: true,
            width: 300,
            sortable:true,
              filter: true,
          },
          columnDefs: this.columnDefs,
          pagination: true,
          animateRows: true,
          paginationPageSize: 10,

          getRowStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              return { background: "#FAFAFA" };
            } else {
              return { background: "#E5E5E5" };
            }
          },
        };
      } else {
        if (this.dlstDeviceType == "Teams") {
          this.gridOptions = {
            defaultColDef: {
              resizable: true,
              width: 150,
              sortable:true,
              filter: true,
            },
            columnDefs: this.columnDefs,
            pagination: true,
            animateRows: true,
            paginationPageSize: 5,

            getRowStyle: function (params) {
              //Req - 2023 - Logic to check for the last index and modify the font style
              if (
                params.node.rowIndex ===
                params.api.getModel().getRowCount()-1
              ) {
                return { "font-weight": "bold" };
              }

              if (params.node.rowIndex % 2 === 0) {
                return { background: "#FAFAFA" };
              } else {
                return { background: "#E5E5E5" };
              }
            },
          };

          // $('#dataGrid').addClass("table-teams");
        } else {
          this.gridOptions = {
            defaultColDef: {
              resizable: true,
              width: 150,
              sortable:true,
              filter: true,
            },
            columnDefs: this.columnDefs,
            pagination: true,
            animateRows: true,
            paginationPageSize: 5,
            

            getRowStyle: function (params) {
              if (params.node.rowIndex % 2 === 0) {
                return { background: "#FAFAFA" };
              } else {
                return { background: "#E5E5E5" };
              }
            },
          };
        }
      }

      this.rowData = data;
      if (
        this.rowData.toString() == "Please Enter valid User EnterpriseID" &&
        this.Type == "CallChargeTeams"
      ) {
        alert("Please enter valid enterprise Id");
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        data.toString() ==
        "Please Enter valid User EnterpriseID and ApplicationID"
      ) {
        alert(
          "Please enter valid enterprise Id or\nPlease enter valid application Id"
        );
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        this.rowData.toString() == "Please Enter valid User EnterpriseID" &&
        this.Type == "Active/DeActiveAuthcode"
      ) {
        alert("Please Enter valid User EnterpriseID");
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        this.rowData.toString() == "Please Enter Valid WBSE" &&
        this.Type == "Active/DeActiveAuthcode"
      ) {
        alert("Please Enter Valid WBSE");
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        this.rowData.toString() == "Please Enter Valid RITM Number" &&
        this.Type == "Active/DeActiveAuthcode"
      ) {
        alert("Please Enter Valid RITM number");
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        this.rowData.length > 0 &&
        (this.Type == "CallCharge" ||
          this.Type == "CountryRecoveryReportTeams" ||
          this.Type == "CallChargeTeams" ||
          this.Type == "CommonAreaPhoneReport" ||
          this.Type == "CiscoCommonAreaPhoneReport" ||
          this.Type == "GroupReport" ||
          this.Type == "RecoveryReports" ||
          this.Type == "RecoveryReportsWithRange" ||
          this.Type == "DialInCallsReports" ||
          this.Type == "ConferenceCallReport" ||
          this.Type == "DialInConferenceCallTeams" ||
          this.Type == "CommonAreaPhoneReportTeams" ||
          this.Type == "CountryReportTeams" ||
          this.Type == "LocationReportTeams" ||
          this.Type == "GhostAuthcodeCallsReport" ||
          this.Type == "FinanceReport" ||
          this.Type == "Active/DeActiveAuthcode")
      ) {
        this.IsRetriveData = true;
        this.IsDataToExport = true;
        this.loaderGif = false;
      } else if (
        this.rowData.length > 0 &&
        (this.Type == "TrunkGroupReport" ||
          this.Type == "GatewayReportTeams" ||
          this.Type == "GatewayReport" ||
          this.Type == "UtilizationReport" ||
          this.Type == "GroupReportTeams" ||
          this.Type == "SMEClusterUtilization")
      ) {
        this.IsRetriveData = true;
        this.IsDataToExport = true;
        this.loaderGif = false;
      } else {
        alert("No Data Available");
        this.IsRetriveData = false;
        this.loaderGif = false;
      }
    });
  }
  ExportToBulkExcel() {
    function validatePhone(txtPhone) {
      const filter = /^[0-9-+]+$/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }

    //this.IsRetriveData = false;
    let message = "";
    const concString = "";
    let Project = "";
    let GatewayNames = "";
    let Telco = "";
    let FacilityNames = "";
    let calltypeNames = "";
    let destinationtypeNames = "";
    let ColumnNames = "";
    let DailInConfNo = "";
    let LocationNames = "";
    let SMEClusterName = "";

    const FinDate = this.culateFinDiff(
      this.Reports.startDateTime,
      this.Reports.EndDate
    );
    const grtDate = this.calculateDiff(
      this.Reports.startDateTime,
      this.Reports.EndDate
    );

    if (this.dlstDeviceType == "") {
      message = "Please Select Device Type";
    }
    if (this.dlstReportType == "") {
      message = message + "\n" + "Please Select Report Type";
    }
    if (this.dlstReportType == "Authcode Activation/Deactivation Report") {
      if ((this.Reports.startDateTime == "" && !this.validate) || (this.Reports.EndDate == "" && !this.validate)) {
      
        message = message + "\n" + "Please enter Start Date and End Date";
      }
      if( (this.Reports.AuthCode == "" && !this.validate) || (this.Reports.WBSE == "" && !this.validate) || (this.Reports.eId == "" && !this.validate) ) {
        message = message + "\n" + "or Authcode/WBS Element/Enterprise ID ";
      } 
    }else
    {
      if (this.Reports.startDateTime == "" && !this.validate) {
        
        message = message + "\n" + "Please Select Start Date";
      }
      
      if (this.Reports.EndDate == "" && !this.validate) {
        
        message = message + "\n" + "Please Select End Date";
  
      }
    }
    if (this.IsCountryChecked) {
      if (this.ReportType == "Country Report") {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.slectedToCountries.length == 0) {
          message = message + "\n" + "Please Select To Country";
        }
      } else {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.Reports.DestinationCountry == "") {
          message = message + "\n" + "Please Select To Country";
        }
      }
    } else if (
      this.ReportType != "SME Cluster Utilization Report" &&
      this.ReportType != "Dial In Conference Call Report" &&
      this.ReportType != "Ghost Authcode Calls Report" &&
      this.ReportType != "Authcode Activation/Deactivation Report" &&
      this.ReportType != "Gateway Report"
    ) {
      if (this.ReportType == "Country Report") {
        if (this.slectedCountries.length == 0)
          message = message + "\n" + "Please Select Country";
      } else if (this.Reports.Country == "" || this.Reports.Country == null) {
        message = message + "\n" + "Please Select Country";
      }
    }
    if (this.dlstReportType == "Call Detail Report") {
      const eid = this.Reports.eId;
      const keywordsArr = eid.split(",");

      if (keywordsArr.length > 5) {
        message =
          message + "\n" + "Please Enter Only 5 or less Enterprise Id's";
      }
    }

    if (this.dlstReportType == "Utilization Reports") {
      if (this.Reports.UtilFacility == "") {
        message = message + "\n" + "Please Select Facility";
      }
    }
    if (this.dlstReportType == "Finance Report") {
      if (
        FinDate == false ||
        grtDate > 32 ||
        this.datePipe.transform(this.Reports.startDateTime, "dd") != "16" ||
        this.datePipe.transform(this.Reports.EndDate, "dd") != "15"
      ) {
        message =
          message +
          "\n" +
          "Kindly Select the Biling Period (16th to 15th of Current Biling Cycle) for the Date Criteria";
      }
      if (this.SelectedFacilities.length == 0) {
        message = message + "\n" + "Please Select Facility";
      }
    }
    if (this.dlstReportType == "Authcode Activation/Deactivation Report") {
      // if (this.SelectedFacilities.length == 0) {
      //   message = message + "\n" + "Please Select Facility";
      // }
      if (this.Reports.callStatus == "") {
        message = message + "\n" + "Please Select Request Type";
      }
    }
    if (this.ReportType == "SME Cluster Utilization Report") {
      if (this.slectedCountries.length == 0) {
        message = message + "\n" + "Please Select Country";
      }
      if (this.selectedSMECluster.length == 0) {
        message = message + "\n" + "Please Select SME Name";
      }
    }
    if (this.dlstReportType != "Recovery Reports") {
      if (this.Reports.callingPartyNumber != "") {
        if (validatePhone(this.Reports.callingPartyNumber)) {
        } else {
          if (this.dlstReportType == "Common Area Phone Report") {
            message =
              message +
              "\n" +
              "Please Enter Numeric in Common Area Phone Number ";
          } else if (this.dlstReportType == "Dial In Conference Call Report") {
            message =
              message + "\n" + "Please Enter Numeric in Conference Call Number";
          } else {
            message = message + "\n" + "Please Enter Numeric in Phone Number ";
          }
        }
      }
      if (this.Reports.CallerNo != "") {
        if (validatePhone(this.Reports.CallerNo)) {
        } else {
          message = message + "\n" + "Please Enter Numeric in Caller Number";
        }
      }
      if (this.Reports.CalleeNo != "") {
        if (validatePhone(this.Reports.CalleeNo)) {
        } else {
          message = message + "\n" + "Please Enter Numeric in Callee Number";
        }
      }
    }
    if (message != "") {
      alert(message);
    } else {
      this.ReportType = this.dlstReportType;
      switch (this.ReportType) {
        case "Call Charge":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          } else {
            this.Type = "CallCharge";
          }
          break;
        case "Trunk Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "TrunkGroupReportTeams";
          } else {
            this.Type = "TrunkGroupReport";
          }
        case "Gateway Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GatewayReportTeams";
          } else {
            this.Type = "GatewayReport";
          }
          break;
        case "Recovery Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "RecoveryReportsTeams";
          } else {
            this.Type = "RecoveryReports";
          }
          break;
        case "Common Area Phone Report":
          {
            /* if (this.dlstDeviceType == 'Teams') {
                this.Type = 'CommonAreaPhoneReportTeams';
            } else {*/
            this.Type = "CommonAreaPhoneReport";
          }
          break;
        case "Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          } else {
            this.Type = "GroupReport";
          }
          break;
        case "Utilization Reports":
          this.Type = "UtilizationReport";
          break;

        case "Dial In Calls Reports":
          this.Type = "DialInCallsReports";
          break;
        case "Common Area Phone Reports":
          this.Type = "CiscoCommonAreaPhoneReport";
          break;
        case "Authcode Mapping Report":
          this.Type = "AuthcodeMappingReport";
          break;
        case "Conference Call Report":
          this.Type = "ConferenceCallReport";
          break;
        case "Ghost Authcode Calls Report":
          this.Type = "GhostAuthcodeCallsReport";
          break;
        case "Finance Report":
          this.Type = "FinanceReport";
          break;
        case "Authcode Activation/Deactivation Report":
          this.Type = "Active/DeActiveAuthcode";
          break;
        case "SME Cluster Utilization Report":
          this.Type = "SMEClusterUtilization";
          break;
        case "Call Detail Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          }
          break;
        case "Call Detail Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          }
          break;
        case "Project/Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          }
          break;
        case "Dial In Conference Call Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInConferenceCallTeams";
          }
          break;
        case "Country Report":
          if (this.dlstDeviceType == "Teams") {
            if (this.IsCountryChecked) {
              this.Type = "CountryReportTeams";
            } else {
              // this.Type = 'CountryReportTeams/CallChargeTeams';
              this.Type = "CountryReportTeams/CountryRecoveryReportTeams";
            }
          }
          break;
        case "Location Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "LocationReportTeams";
          }
          break;
      }

      for (var i = 0; i < this.SelectedProjectNames.length; i++) {
        Project = Project + "," + this.SelectedProjectNames[i].label;
      }
      for (var i = 0; i < this.SelectedGatewayNames.length; i++) {
        GatewayNames = GatewayNames + "," + this.SelectedGatewayNames[i].label;
      }
      for (var i = 0; i < this.selectedDailInConff.length; i++) {
        DailInConfNo = DailInConfNo + "," + this.selectedDailInConff[i].label;
      }
      for (var i = 0; i < this.SelectedTelcoProviders.length; i++) {
        Telco = Telco + "," + this.SelectedTelcoProviders[i].label;
      }
      if (this.DeviceType == "Teams") {
        for (var i = 0; i < this.slectedTeamsCallType.length; i++) {
          calltypeNames =
            calltypeNames + "," + this.slectedTeamsCallType[i].label;
        }
        this.Reports.callType = calltypeNames.slice(1, calltypeNames.length);
      } else {
        for (var i = 0; i < this.selectedCallType.length; i++) {
          //calltypeNames = calltypeNames + ',' + this.selectedCallType[i].label + ' Calls';
          calltypeNames = calltypeNames + "," + this.selectedCallType[i].label;
        }
        this.Reports.callType = calltypeNames.slice(1, calltypeNames.length);
      }
      for (var i = 0; i < this.selectedDestDeviType.length; i++) {
        //destinationtypeNames = destinationtypeNames + ',' + this.selectedDestDeviType[i].label + ' Calls';
        destinationtypeNames =
          destinationtypeNames + "," + this.selectedDestDeviType[i].label;
      }
      this.Reports.Destination = destinationtypeNames.slice(
        1,
        destinationtypeNames.length
      );
      for (var i = 0; i < this.selectedLocation.length; i++) {
        LocationNames = LocationNames + "," + this.selectedLocation[i].label;
      }
      this.Reports.Location = LocationNames.slice(1, LocationNames.length);

      for (var i = 0; i < this.SelectedFacilities.length; i++) {
        FacilityNames = FacilityNames + "~" + this.SelectedFacilities[i].label;
      }
      for (var i = 0; i < this.ColumnType.length; i++) {
        ColumnNames = ColumnNames + "," + this.ColumnType[i].label;
      }
      if (this.ReportType == "SME Cluster Utilization Report") {
        let countrySummaryCountry = "";
        for (var i = 0; i < this.slectedCountries.length; i++) {
          countrySummaryCountry =
            countrySummaryCountry + "," + this.slectedCountries[i].label;
        }
        this.Reports.Country = countrySummaryCountry.slice(
          1,
          countrySummaryCountry.length
        );
        for (var i = 0; i < this.selectedSMECluster.length; i++) {
          SMEClusterName =
            SMEClusterName + "," + this.selectedSMECluster[i].label;
        }
        this.Reports.SMEName = SMEClusterName.slice(1, SMEClusterName.length);
      }
      this.Reports.Column = ColumnNames.slice(1, ColumnNames.length);
      this.Reports.destDeviceName = concString.slice(1, concString.length);
      this.Reports.ProjectName = Project.slice(1, Project.length);
      this.Reports.toGateway = GatewayNames.slice(1, GatewayNames.length);
      this.Reports.telcoName = Telco.slice(1, Telco.length);
      this.Reports.ProjectLead = this.LoginEnterpriseID;
      this.Reports.Facility = FacilityNames.slice(1, FacilityNames.length);
      this.Reports.DailInConference = DailInConfNo.slice(
        1,
        DailInConfNo.length
      );
      let Enddate = "";
      if (this.Reports.utilizationtype == "Hourly") {
        Enddate = this.formatDateValue(this.Reports.startDateTime);
      } else if(!(this.Reports.EndDate=="")) {
        Enddate = this.formatDateValue(this.Reports.EndDate);
      }

      // this.CAPService.ExportRecoveryReports(this.Reports,this.formatDateValue(this.Reports.startDateTime) , Enddate, this.Type ).subscribe(resp =>{
      //
      //   if(resp.length > 0){
      //     this.loaderGif = true;
      //     var ReportName = this.dlstReportType +'.xlsx';
      //     if(this.DeviceType == "Teams"){
      //       var filter= null;
      //       if(this.ReportType =="Call Detail Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //           "Call Type":this.Reports.callType,Facility:this.Reports.Facility,"Phone Number":this.Reports.callingPartyNumber,"Caller Number":this.Reports.CallerNo,"Callee Number":this.Reports.CalleeNo,"Destination Type":this.Reports.Destination,
      //           "Enterprise ID":this.Reports.eId,"Event Type":this.Reports.Event}];
      //       }
      //       else if(this.ReportType =="Gateway Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //          "Call Type":this.Reports.callType,Facility:this.Reports.Facility,"Gateway Name":this.Reports.toGateway,"Destination Type":this.Reports.Destination,
      //          "Event Type":this.Reports.Event}];
      //       }
      //       else if(this.ReportType =="Project/Group Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //          "Call Type":this.Reports.callType,Facility:this.Reports.Facility,"Project Name":this.Reports.ProjectName,"Destination Type":this.Reports.Destination,
      //          "Event Type":this.Reports.Event}];
      //       }
      //       else if(this.ReportType =="Common Area Phone Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //          "Call Type":this.Reports.callType,Facility:this.Reports.Facility,"Common Area Phone Number":this.Reports.callingPartyNumber,"Destination Type":this.Reports.Destination,
      //          "Event Type":this.Reports.Event}];
      //       }
      //       else if(this.ReportType =="Dial In Conference Call Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //          "Call Type":this.Reports.callType,Facility:this.Reports.Facility,"Conference Call Number":this.Reports.callingPartyNumber,"Destination Type":this.Reports.Destination,
      //          "Event Type":this.Reports.Event,"Dial In Conference Call Number":this.Reports.DailInConference}];
      //       }
      //       else if(this.ReportType =="Country Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //           "From Country":this.Reports.SourceCountry,"To Country":this.Reports.DestinationCountry,"Call Type":this.Reports.callType,"Event Type":this.Reports.Event}];
      //       }
      //       else if(this.ReportType =="Location Report"){
      //          filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,Country:this.Reports.Country,
      //         Location:this.Reports.Location,"Call Type":this.Reports.callType,"Event Type":this.Reports.Event}];
      //       }

      //     var opts = [{sheetid:'Filters',header:true},{sheetid:'Data',header:true}];
      //     alasql.default('SELECT INTO XLSX("'+ ReportName +'",?) FROM ?',[opts,[filter,resp]]);
      //  }
      //  else if(this.DeviceType == "Cisco") {
      //   alasql.default('SELECT INTO XLSX("'+ ReportName +'", {headers:true}) FROM ?', [resp]);
      //   }
      //     this.loaderGif = false;
      //   }
      //   else{
      //     alert('No Data Available');
      //     this.loaderGif = false;
      //   }
      // }, err=>{
      //   console.log(err);
      //   console.log('error while downloading file....');
      // });
      this.loaderGif = true;
      //2023 requirement Bulk upload feature for Call details report instead of 5 userid search
      this.TempUserKey = "";
      this.Reports.BulkUploadUserId = "";
      const ReportName = this.dlstReportType + ".xlsx";
      if (
        this.bulkFile != "" &&
        this.bulkFile != undefined &&
        this.diveid &&
        this.divteamscall3
      ) {
        this.loaderGif = true;
        const file = this.recoveryReportFG.controls.inputFile.value;
        const ext = file.split(".").pop().toLowerCase();
        if (file == "") {
          alert("Please Upload The Template");
          this.loaderGif = false;
          return;
        }
        if (ext != "xls" && ext != "xlsx") {
          alert(
            "Please upload only Excel file with .xls or .xlsx extension only"
          );
          $("#fileControl").val("");
          this.loaderGif = false;
        } else {
          const formData = new FormData();
          formData.append("file", this.bulkFile);
          this.CAPService.UploadBulkEidTemplate(
            this.LoginEnterpriseID,
            formData
          ).subscribe((data) => {
            this.BulkUploaddata = data;
            //this.recoveryReportFG.controls.inputFile.setValue('');
            this.TempUserKey = this.BulkUploaddata.TempUserName;
            if (this.TempUserKey != "") {
              this.Reports.BulkUploadUserId = this.TempUserKey;
              this.CAPService.ExportRecoveryReports1(
                this.Reports,
                this.formatDateValue(this.Reports.startDateTime),
                Enddate,
                this.Type
              ).subscribe(
                (data: Blob) => {
                  
                  if (data.size > 0) {
                    if (
                      window.navigator &&
                      (window.navigator as any).msSaveOrOpenBlob
                    ) {
                      // for IE
                      (window.navigator as any).msSaveOrOpenBlob(
                        data,
                        ReportName
                      );
                      this.loaderGif = false;
                    } else {
                      const link = document.createElement("a");
                      link.href = window.URL.createObjectURL(data);
                      link.download = ReportName;
                      link.click();
                      this.loaderGif = false;
                    }
                  } else {
                    alert("No Records Found");
                    this.loaderGif = false;
                  }
                },
                function (x) {
                  this.loaderGif = false;
                  alert("Acknowledgement failed");
                }
              );
            } else {
              this.loaderGif = false;
              alert(this.BulkUploaddata.StrMessage);
            }
          });
        }
      } else {
        
        if(this.dlstReportType.toString().startsWith("Authcode") && this.Reports.startDateTime == "" && this.Reports.EndDate == "")
        {
        
         this.CAPService. ExportAuthcodedecative(this.Reports,this.Type).subscribe((data)=>{
          if (data.size > 0) {
            
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.loaderGif = false;
            } else {
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.loaderGif = false;
            }
          } else {
            alert("No Records Found");
            this.loaderGif = false;
          }
        },
        function (x) {
          this.loaderGif = false;
          alert("Acknowledgement failed");
        }
         )
        }
        else{
         
          this.CAPService.ExportRecoveryReports1(
          this.Reports,
          this.formatDateValue(this.Reports.startDateTime),
          Enddate,
          this.Type
        ).subscribe(
          (data: Blob) => {
          
            if (data.size > 0) {
              if (
                window.navigator &&
                (window.navigator as any).msSaveOrOpenBlob
              ) {
                // for IE
                (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
                this.loaderGif = false;
              } else {
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(data);
                link.download = ReportName;
                link.click();
                this.loaderGif = false;
              }
            } else {
              alert("No Records Found");
              this.loaderGif = false;
            }
          },
          function (x) {
            this.loaderGif = false;
            alert("Acknowledgement failed");
          }
        );
      }
    }
    }
  }

  ExportToExcel() {
    this.loaderGif = true;
    const ReportName = this.dlstReportType + ".xlsx";
    if (this.DeviceType == "Teams") {
      let filter = null;
      if (this.ReportType == "Call Detail Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Call Type": this.Reports.callType,
            Facility: this.Reports.Facility,
            "Phone Number": this.Reports.callingPartyNumber,
            "Caller Number": this.Reports.CallerNo,
            "Callee Number": this.Reports.CalleeNo,
            "Destination Type": this.Reports.Destination,
            "Enterprise ID": this.Reports.eId,
            "Event Type": this.Reports.Event,
          },
        ];
      } else if (this.ReportType == "Gateway Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Call Type": this.Reports.callType,
            Facility: this.Reports.Facility,
            "Gateway Name": this.Reports.toGateway,
            "Destination Type": this.Reports.Destination,
            "Event Type": this.Reports.Event,
          },
        ];
      } else if (this.ReportType == "Project/Group Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Call Type": this.Reports.callType,
            Facility: this.Reports.Facility,
            "Project Name": this.Reports.ProjectName,
            "Destination Type": this.Reports.Destination,
            "Event Type": this.Reports.Event,
          },
        ];
      } else if (this.ReportType == "Dial In Conference Call Report") {
        /*2023 Requirement -- removal of Common Area Phone Report
      else if(this.ReportType =="Common Area Phone Report"){
         filter = [{"Device Type": this.DeviceType,"Report Type" :this.ReportType,"Start Date":this.Reports.startDateTime,"End Date":this.Reports.EndDate,"User Country":this.Reports.Country,
         "Call Type":this.Reports.callType,Facility:this.Reports.Facility,"Common Area Phone Number":this.Reports.callingPartyNumber,"Destination Type":this.Reports.Destination,
         "Event Type":this.Reports.Event}];      
      }*/
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Call Type": this.Reports.callType,
            Facility: this.Reports.Facility,
            "Conference Call Number": this.Reports.callingPartyNumber,
            "Destination Type": this.Reports.Destination,
            "Event Type": this.Reports.Event,
            "Dial In Conference Call Number": this.Reports.DailInConference,
          },
        ];
      } else if (this.ReportType == "Country Report") {
        if (this.IsCountryChecked) {
          filter = [
            {
              "Device Type": this.DeviceType,
              "Report Type": this.ReportType,
              "Start Date": this.Reports.startDateTime,
              "End Date": this.Reports.EndDate,
              "From Country": this.Reports.SourceCountry,
              "To Country": this.Reports.DestinationCountry,
              "Call Type": this.Reports.callType,
              "Event Type": this.Reports.Event,
            },
          ];
        } else {
          filter = [
            {
              "Device Type": this.DeviceType,
              "Report Type": this.ReportType,
              "Start Date": this.Reports.startDateTime,
              "End Date": this.Reports.EndDate,
              "User Country": this.Reports.Country,
              "Call Type": this.Reports.callType,
              "Event Type": this.Reports.Event,
            },
          ];
        }
      } else if (this.ReportType == "Location Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            Location: this.Reports.Location,
            "Call Type": this.Reports.callType,
            "Event Type": this.Reports.Event,
          },
        ];
      } else if (this.ReportType == "Ghost Authcode Calls Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            Location: this.Reports.Location,
            "Call Type": this.Reports.callType,
            "Event Type": this.Reports.Event,
          },
        ];
      }

      const opts = [
        { sheetid: "Filters", header: true },
        { sheetid: "Data", header: true },
      ];
      // alasql.default('SELECT INTO XLSX("' + ReportName + '",?) FROM ?', [
      //   opts,
      //   [filter, this.rowData],
      // ]);
      this.loaderGif = false;
    } else {
      // alasql.default(
      //   'SELECT INTO XLSX("' + ReportName + '", {headers:true}) FROM ?',
      //   [this.rowData]
      // );
      // this.loaderGif = false;
    }
    this.loaderGif = false;
  }

  downloadFile(data: any) {
    //const blob = new Blob([data], { type: 'application/octet-stream' });
    const blob = new Blob([data], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  setFile(files: FileList) {
    debugger;
    this.bulkFile = files.item(0);
    this.Reports.BulkUploadUserId = "";
  }
}

export class ReportDetails {
  public Country;
  public Facility;
  public callType;
  public eId;
  public callStatus;
  public startDateTime;
  public EndDate;
  public fromMediationServer;
  public toGateway;
  public destDeviceName;
  public callingPartyNumber;
  public ProjectName;
  public telcoName;
  public utilizationtype;
  public ProjectLead;
  public ValidInvalid;
  public Status;
  public WBSE;
  public RITMNumber;
  public originalCalledPartyNumber;
  public AuthCode;
  public MarkStatus;
  public RequestNumber;
  public CallingPartyNumber;
  public ExcludeNumber;
  public CallDirection;
  public UtilizationsFacility;
  public CallStatus;
  public Location;
  public Destination;
  public Event;
  public CalleeNo;
  public CallerNo;
  public Column;
  public fromAuthcode;
  public toAuthcode;
  public fromCalling;
  public toCalling;
  public fromCalled;
  public toCalled;
  public fromExclude;
  public toExclude;
  public DailInConference;
  public Empno;
  public AuthStatus;
  public SourceCountry;
  public DestinationCountry;

  public fromDuration;
  public toDuration;
  public fromCost;
  public toCost;
  public UtilFacility;
  public RequestType;
  public BulkUploadUserId;
  // 2023 sprint 4 changes
  public SMEName;
}
